// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:12.241Z
// Property: Mariner's Pointe (ID: 6767906449166329)
// Collections: 28 amenities, 15 floorplans (live), 20 photos, 82 POIs, 5 reviews, 5 virtual tours, 6 office hours, 4 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166329",
  "property_external_id": "30951",
  "property_zillow_url": "https://www.zillow.com/apartments/joppa-md/mariners-pointe/5Xt9GW/",
  "property_apartments_url": "https://www.apartments.com/mariners-pointe-joppa-md/lccf78f/",
  "property_google_business_url": "https://www.google.com/maps/place/Mariner's+Pointe/data=!4m2!3m1!1s0x0:0x9aaec3146cee0ecf?sa=X&ved=2ahUKEwiipsiWvbiSAxX_48kDHVLmKk4Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52817609217",
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "mariner's-pointe",
  "property_name": "Mariner's Pointe",
  "property_website_url": "https://www.livemarinerspointe.com/",
  "property_domain": "https://www.livemarinerspointe.com/",
  "property_address": "311 Trimble Road",
  "property_full_address": "311 Trimble Rd, Joppatowne, MD 21085",
  "property_address_1": "311 Trimble Rd",
  "property_address_2": null,
  "property_address_city": "Joppatowne",
  "property_address_state": "MD",
  "property_address_zip_full": "21085-3815",
  "property_address_zip": "21085",
  "property_address_country": "US",
  "property_address_county": "Harford County",
  "property_neighborhood_address": "Joppa",
  "property_address_latitude": "39.42146109999999",
  "property_address_longitude": "-76.3686123",
  "property_email": "marinerspointe@aionmanagement.com",
  "property_phone": "(410) 679-2104",
  "property_call_tracking_phone": "844-553-0518",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p>Enjoy our newly updated one-, two-, and three- bedroom apartment homes for rent in Joppatowne, Maryland.</p>",
  "property_long_description": "<p>Find your perfect fit in a great location in Harford County with a one, two, or three bedroom apartment or townhome at Mariner's Pointe. This pet-friendly community features amenities designed to simplify your life and a friendly vibe that will make you feel welcome from day one. Our spacious floor plans have been thoughtfully upgraded for style and comfort. You’ll love the convenience of this Joppatowne location, with an array of shops, restaurants, and entertainment options at your fingertips.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd912-5f65-752e-87d5-2db900b2cc09.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
    "public_id": "019fd912-5f65-752e-87d5-2db900b2cc09",
    "storage_key": "property/6767906449166329/019fd912-5f65-752e-87d5-2db900b2cc09.webp",
    "width": 1920,
    "height": 1217
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "466",
  "property_year_built": "1963",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.56652360515021",
  "property_admin_fee": null,
  "property_application_fee": "25",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum of 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "We’re a pet-friendly community and we’re happy to welcome your cats and dogs. Breed restrictions apply; please contact the leasing office for details. You can have up to 2 pets per apartment, with each pet up to 100 lb. There is a one-time, non-refundable pet fee of $350 and monthly pet rent is $50.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://marinerspointe.loftliving.com/login",
  "property_apply_now_url": "https://www.livemarinerspointe.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d026a-343f-70a6-a01a-e0f3264729b4.webp",
  "property_primary_logo_media": {
    "alt_text": "Mariner's Pointe Apartment Homes logo",
    "public_id": "019d026a-343f-70a6-a01a-e0f3264729b4",
    "storage_key": "property/6767906449166329/019d026a-343f-70a6-a01a-e0f3264729b4.webp",
    "width": 275,
    "height": 79
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d026a-2a49-7128-b6df-f3dd55fff60e.webp",
  "property_secondary_logo_media": {
    "alt_text": "AIon Management logo",
    "public_id": "019d026a-2a49-7128-b6df-f3dd55fff60e",
    "storage_key": "property/6767906449166329/019d026a-2a49-7128-b6df-f3dd55fff60e.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d026a-3df0-7179-9e9d-298db687dc8f.webp",
  "property_icon_media": {
    "alt_text": "Compass logo inside a hexagonal frame",
    "public_id": "019d026a-3df0-7179-9e9d-298db687dc8f",
    "storage_key": "property/6767906449166329/019d026a-3df0-7179-9e9d-298db687dc8f.webp",
    "width": 144,
    "height": 144
  },
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d026a-4add-767c-893e-f39124d2fdf3.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Mariner's Pointe Apartment Homes logo",
    "public_id": "019d026a-4add-767c-893e-f39124d2fdf3",
    "storage_key": "property/6767906449166329/019d026a-4add-767c-893e-f39124d2fdf3.webp",
    "width": 275,
    "height": 79
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d026a-5447-7373-a05f-4d0f870e9849.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Mariner's Pointe Apartment Homes logo with compass icon.",
    "public_id": "019d026a-5447-7373-a05f-4d0f870e9849",
    "storage_key": "property/6767906449166329/019d026a-5447-7373-a05f-4d0f870e9849.webp",
    "width": 275,
    "height": 79
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "750 - 1080",
  "property_sqft_min": "750",
  "property_sqft_max": "1080",
  "property_price_range": "1165 - 1766",
  "property_price_min": "1165",
  "property_price_max": "1766",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/livemarinerspointe",
  "property_instagram_url": "https://www.instagram.com/livemarinerspointe/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJxzKJ81Xhx4kRzw7ubBTDrpo",
  "property_youtube_url": "https://www.youtube.com/watch?v=007hO1jVmGs",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Bridge&find_loc=Kingsville%2C+MD+21087",
  "property_tiktok_url": "https://www.tiktok.com/@marinerspointejop",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Mariner's Pointe",
  "property_home_romance_title": "Embrace the Joy of Living in Your New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Mariner's Pointe in Joppatowne, MD, where modern living meets convenience. Choose from spacious one, two, or three-bedroom floor plans, each featuring thoughtful amenities. Enjoy our dog park, playground, and easy access to nearby parks and shopping. Experience comfort with renovated interiors, private balconies, and 24-hour maintenance, tailored to elevate your lifestyle.",
  "property_home_floorplans_blurb": "Welcome to Mariner's Pointe in Joppatowne, MD, where comfort meets style. Offering thoughtfully designed one, two, and three-bedroom apartments, each space caters to your lifestyle. Dive into a world of possibilities and find your perfect floor plan today—your ideal home awaits!",
  "property_home_gallery_blurb": "At Mariner's Pointe in Joppatowne, MD, your ideal home awaits—choose from spacious one, two, or three-bedroom apartments and townhomes. Enjoy an array of amenities, including a dog park, playground, and easy access to Mariner Point Park. Picture yourself here, where comfort and convenience blend seamlessly!",
  "property_home_neighborhood_blurb": "Welcome to Mariner's Pointe in Joppatowne, MD, where vibrant living meets serene landscapes. Choose from spacious one, two, or three-bedroom floor plans, and enjoy nearby gems like Havre De Grace Decoy Museum, Susquehanna State Park, and Harford Community College. Experience a community where convenience and culture collide!",
  "property_home_reviews_blurb": "At Mariner's Pointe in Joppatowne, MD, our residents rave about the exceptional care provided by our maintenance team. One resident shared, \"James and Joe went above and beyond for me.\" Experience spacious, affordable living in a safe, friendly community—where neighbors become friends and prompt service is a priority.",
  "property_neighborhood_blurb": "Nestled in Joppatowne, MD, Mariner's Pointe is your gateway to vibrant community life. Enjoy cultural gems like the Havre De Grace Decoy Museum and serene parks such as Susquehanna State Park. With top-rated schools and convenient access to local businesses, find your perfect home surrounded by endless possibilities.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Mariner's Pointe in Joppatowne, MD, you’ll find a haven of comfort and convenience. Choose from our stylish one, two, or three-bedroom apartments, complete with modern amenities. Enjoy the playground, dog park, and bicycle storage, all just minutes from White Marsh Town Center and tranquil Mariner Point Park.",
  "property_applynow_blurb": "At Mariner's Pointe in Joppatowne, MD, choose from versatile one, two, and three-bedroom floor plans designed for your lifestyle. Enjoy modern amenities like a dog park, playground, and soon-to-come fitness center, all just minutes from Mariner Point Park and White Marsh Town Center. Find your new home and lease online today!",
  "property_contactus_blurb": "At Mariner's Pointe in Joppatowne, MD, each floor plan reflects modern living with style and comfort. Choose from our spacious one, two, or three-bedroom apartments, tailored for your lifestyle. Have questions? Contact our leasing team today and embark on your next adventure in vibrant apartment living!",
  "property_faqs_blurb": "At Mariner's Pointe in Joppatowne, MD, we offer versatile floor plans tailored to your lifestyle—one, two, and three-bedroom options await. Experience community living that caters to your needs! Dive into our FAQs page for insights and answers that enrich your journey to finding the perfect home.",
  "property_floorplans_blurb": "At Mariner's Pointe in Joppatowne, MD, a variety of thoughtfully designed floor plans awaits you. Whether you're seeking a cozy one-bedroom, a spacious two-bedroom, or a family-friendly three-bedroom, each layout offers comfort and style. Browse our available apartment homes today and find your ideal fit!",
  "property_gallery_blurb": "At Mariner's Pointe in Joppatowne, MD, your ideal living space awaits! Picture cozy one, two, and three-bedroom homes featuring renovated kitchens and spacious layouts. Enjoy community perks like a dog park, playground, and EV charging. With quick access to parks, shopping, and Baltimore, vibrant living is just a heartbeat away!",
  "property_interactivemap_blurb": "At Mariner's Pointe in Joppatowne, MD, your next home awaits with spacious one, two, and three-bedroom options. Enjoy top-notch amenities like a dog park, playground, and EV charging stations—all just minutes from Mariner Point Park and White Marsh Town Center. Dive into our interactive community map to find your perfect space!",
  "property_pets_blurb": "At Mariner's Pointe in Joppatowne, MD, your pets are more than just companions—they're family! With a spacious pet-friendly policy, both cats and dogs can revel in their new home. Enjoy community living while ensuring your furry friends have a cozy retreat tailored just for them.",
  "property_referafriend_blurb": "At Mariner's Pointe in Joppatowne, MD, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans tailored for relaxed living. Great friends make great neighbors—refer a friend today and enjoy the vibrant community together. Your ideal lifestyle is just a referral away!",
  "property_residentaccess_blurb": "Welcome to Mariner's Pointe in Joppatowne, MD, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans tailored to fit your lifestyle. Connect effortlessly through our resident portal for rent payments, maintenance requests, and more, making apartment living seamless and enjoyable.",
  "property_reviews_blurb": "At Mariner's Pointe in Joppatowne, MD, our residents cherish the exceptional service provided by our dedicated maintenance team. One resident raved, “The whole maintenance team is great…Always go out of their way!” Experience a welcoming community where friendly support and well-kept grounds enhance your living experience. Read more reviews! ",
  "property_created_at": "1757006962531",
  "property_scheduletour_blurb": "At Mariner's Pointe in Joppatowne, MD, choose from thoughtfully designed one, two, or three-bedroom floor plans that elevate your living experience. Schedule a tour today and hear directly from our residents about the vibrant community and exceptional amenities that make Mariner’s Pointe their home sweet home!",
  "property_thankyou_blurb": "Thank you for your interest in Mariner's Pointe, where modern living meets coastal charm in Joppatowne, MD. Our thoughtfully designed one, two, and three-bedroom floor plans offer a perfect blend of comfort and style. A dedicated team member will be in touch soon to help you on your journey to your new home!",
  "property_virtualtours_blurb": "At Mariner's Pointe in Joppatowne, MD, choose from our thoughtfully designed one, two, or three-bedroom apartments, perfect for your lifestyle. Experience the vibrant community and stunning amenities—take a virtual tour today and envision your next home with us!",
  "property_copyright": "2025 All Rights Reserved. Mariner's Pointe",
  "property_seo_title_home": "Mariner's Pointe |  Apartments in Joppatowne, MD",
  "property_seo_description_home": "Experience comfort at Mariner's Pointe, Joppatowne! Choose 1-3 bedroom apartments with spacious amenities near parks and shops.",
  "property_seo_title_floorplans": "Floor Plans | Joppatowne, MD Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal living space at Mariner’s Pointe in Joppatowne, MD! From cozy one-bedrooms to spacious three-bedrooms, browse floor plans tailored for you.",
  "property_seo_title_amenities": "Amenities | Joppatowne, MD Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Mariner's Pointe in Joppatowne, MD! Enjoy stunning apartments, a playground, dog park, and more. Short-term leases & easy commutes await!",
  "property_seo_title_gallery": "Gallery | Apartments in Joppatowne, MD",
  "property_seo_description_gallery": "Discover comfort at Mariner's Pointe, Joppatowne, MD! Enjoy spacious 1-3 bedroom homes, modern amenities, a dog park, and quick access to Baltimore.",
  "property_seo_title_virtualtours": "Virtual Tours | Mariner's Pointe Apartments",
  "property_seo_description_virtualtours": "Take a virtual tour of Mariner's Pointe in Joppatowne, MD. Explore our spacious 1, 2, and 3-bedroom floor plans and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Mariner's Pointe Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Mariner's Pointe! Use our interactive map to browse spacious layouts, modern amenities, and life near parks, shops, and Baltimore!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Joppatowne, MD",
  "property_seo_description_neighborhood": "Experience Joppatowne living at Mariner's Pointe! Uncover hidden gems and vibrant local favorites just steps from your new one, two, or three-bedroom home.",
  "property_seo_title_contact": "Contact Us | Mariner's Pointe",
  "property_seo_description_contact": "Connect with Mariner's Pointe in Joppatowne, MD! Explore our one, two, and three-bedroom floor plans. Questions? Our leasing team is ready to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Joppatowne, MD",
  "property_seo_description_faqs": "Find answers to your questions about life at Mariner's Pointe in Joppatowne, MD. From amenities to floor plans, we’ve got you covered. Check out our FAQs!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Joppatowne, MD",
  "property_seo_description_reviews": "Experience life at Mariner's Pointe in Joppatowne, MD! Check out resident reviews and find spacious apartments, modern amenities, and a vibrant community vibe!",
  "property_seo_title_applynow": "Apply Now | Apartments in Joppatowne, MD",
  "property_seo_description_applynow": "Discover vibrant living at Mariner's Pointe, Joppatowne, MD! Choose from spacious 1-3 bedroom apartments with great amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Mariner's Pointe",
  "property_seo_description_residentaccess": "Welcome to Mariner's Pointe! Access your resident portal for rent payments, maintenance requests, and exclusive community updates in Joppatowne, MD.",
  "property_seo_title_referafriend": "Refer A Friend | Mariner's Pointe",
  "property_seo_description_referafriend": "Share the love at Mariner's Pointe! Refer a friend and enjoy a vibrant community in Joppatowne, MD. Great friends make great neighbors—join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Mariner's Pointe",
  "property_seo_description_scheduletour": "Experience the charm of Mariner's Pointe in Joppatowne, MD. Schedule a tour today and envision your future in our vibrant apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Mariner's Pointe",
  "property_seo_description_privacy": "At Mariner's Pointe in Joppatowne, MD, your privacy matters! Check out our policy to see how we protect your information while you enjoy coastal living.",
  "property_seo_title_accessibility": "Website Accessibility | Mariner's Pointe",
  "property_seo_description_accessibility": "At Mariner's Pointe in Joppatowne, MD, we prioritize accessibility for all. Join us in fostering an inclusive community where everyone feels at home!",
  "property_seo_title_sitemap": "Sitemap | Mariner's Pointe",
  "property_seo_description_sitemap": "Unearth the charm of Mariner's Pointe in Joppatowne, MD. Navigate our site to find your ideal home and community treasures with ease. Explore our sitemap now!",
  "property_seo_title_thankyou": "Thank You | Mariner's Pointe",
  "property_seo_description_thankyou": "Thank you for reaching out to Mariner's Pointe in Joppatowne, MD! A team member will be in touch soon to help you find your ideal home by the water.",
  "property_seo_title_pets": null,
  "property_seo_description_pets": null,
  "property_updated_at": "1791293669693",
  "amenities": [
    {
      "id": "custom_dbab753a-0cea-4bdb-b560-c4175081aa05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center*",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2f0a3759-1554-4267-9596-e1fbbd6c66b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_53a8cc41-9dc7-4dfb-a9a4-ea8486319b55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7297776e-06b2-452d-bedb-491fe6f05072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df2ffaf9-28f6-4261-93ff-abf0057bbfe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ffee357f-2994-4473-a978-18bffecb28eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a79487b3-7940-4459-b19b-8ffb28ac3534",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c248414e-d85b-429b-9378-48be2e8476f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Storage Space Available",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50213322-b466-42d2-a81e-5cac656af3a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7f7463ee-c32d-44e6-bc43-0faa8c3cd6f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_de827f08-d34a-4819-90da-4a4b0e2f278f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7fae83a3-c44f-49ff-8561-7227a3b725fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "High-Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0599e3bf-bb38-47b9-8c23-39e3236dafcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_466adddb-ca45-46b8-8562-a3b508186f91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Plank Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c151b347-5f86-41e8-8397-a0c2731519f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cbbbf320-0a42-4772-bd52-65b1adb71272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Bathrooms*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_163240f5-e636-4c98-9a94-30f10e57eaff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Kitchens*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5138aa7c-b222-40bf-a7b1-af6c44648b71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless-Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d02755f4-c096-40b4-95a1-c693643339cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49b23584-668c-44bf-811d-01b8ed6b5d1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Easy access to State Highway 40 and I-95",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5692fb94-053c-46b6-b43d-2de09c20e1ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "3.5 miles to White Marsh Town Center and The Avenue at White Marsh",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3767b24a-6b50-431f-84a6-2cf37d090573",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "5 minutes to Mariner Point Park",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0d4ec8d0-7ad0-4553-b32e-1aaea483e01c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a9a67e77-ea18-4031-9fcd-f62fe1f79894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95228d3f-a521-4718-bbaa-a91542a708ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Free Off-Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4629596e-f1ce-4ae6-a35d-a9fb9d5eeb1b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_329fbacc-ff81-4b65-b228-457d34dde45a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Parking Available",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3430fe16-7da7-4b8f-a794-84ea16293e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "external_id": "false",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a54f4650-200a-4387-b48d-1c277e6837cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-c7b1-77dc-8d1a-83c30e576095.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, stainless steel appliances, and a stacked washer/dryer.",
        "public_id": "019fd925-c7b1-77dc-8d1a-83c30e576095",
        "storage_key": "property/6767906449166329/019fd925-c7b1-77dc-8d1a-83c30e576095.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite counters.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/a15a33e5697735582b7a01d96584a4ac-1920w.jpg"
    },
    {
      "id": "custom_e653e759-00bd-43b0-9007-1fd7654bd5fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-c7c3-7559-a557-cc6ea818ed07.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, nightstand, bench, and wall shelves.",
        "public_id": "019fd925-c7c3-7559-a557-cc6ea818ed07",
        "storage_key": "property/6767906449166329/019fd925-c7c3-7559-a557-cc6ea818ed07.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "A modern, furnished apartment bedroom with a queen bed, nightstand, shelves, a bench, and abstract art.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a queen bed, nightstand, window, wall art, and floating shelves.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/65cb9685107c8a4e2750ff968ef1f8d9-1920w.jpg"
    },
    {
      "id": "custom_41afea88-8f5f-4c7e-9428-3b31a540cf9b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-c803-73c4-ac0c-e20bc7657799.webp",
      "image_media": {
        "alt_text": "Stylish living room with a couch, coffee table, and TV.",
        "public_id": "019fd925-c803-73c4-ac0c-e20bc7657799",
        "storage_key": "property/6767906449166329/019fd925-c803-73c4-ac0c-e20bc7657799.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, contemporary living space in a modern apartment with neutral tones, a comfortable sofa, glass coffee table, TV, and access to a patio via sliding doors.",
      "link": "false",
      "alt_text": "Modern apartment living room with beige sofa, glass coffee table, TV, and sliding glass door with blinds.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/e7cd5d564dd84b28ecfda565d8d0ec7a-1920w.jpg"
    },
    {
      "id": "custom_26fa296c-94fe-4421-b84b-1108ac31f50f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-c7b6-74cd-ad0e-198a4789b0db.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019fd925-c7b6-74cd-ad0e-198a4789b0db",
        "storage_key": "property/6767906449166329/019fd925-c7b6-74cd-ad0e-198a4789b0db.webp",
        "width": 1920,
        "height": 1223
      },
      "title": "Apartment",
      "description": "Sleek, modern apartment kitchen featuring granite countertops, stainless appliances, and a connected laundry area.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a stacked washer/dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/ab7fc6e73f0724cf3c1432ef9a0a8182-1920w.jpg"
    },
    {
      "id": "custom_fbf92258-d9d1-455d-8d0d-596ff84e6af5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-d35e-770e-bfa4-87c9eed194c4.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, TV, and a view into the laundry area.",
        "public_id": "019fd925-d35e-770e-bfa4-87c9eed194c4",
        "storage_key": "property/6767906449166329/019fd925-d35e-770e-bfa4-87c9eed194c4.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Open-concept living area with sofa, coffee table, TV, and visible kitchen.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/2b01bd0ac1b78269106b85bbb848604b-1920w.jpg"
    },
    {
      "id": "custom_ae266dd5-98e4-4d3e-80f6-2de9b02d809f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-d33d-7172-b6c4-400ab6bf1348.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019fd925-d33d-7172-b6c4-400ab6bf1348",
        "storage_key": "property/6767906449166329/019fd925-d33d-7172-b6c4-400ab6bf1348.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Narrow galley kitchen with white Shaker cabinets, granite countertops, stainless steel refrigerator, stove, microwave, and sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/aa738df13b9228e028a2342c9bf44359-1920w.webp"
    },
    {
      "id": "custom_3c34b7f8-60ea-42c7-bb56-f8f47c579c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-d37b-739e-a3d0-bdc897b32083.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, dark wood cabinets, and granite countertops.",
        "public_id": "019fd925-d37b-739e-a3d0-bdc897b32083",
        "storage_key": "property/6767906449166329/019fd925-d37b-739e-a3d0-bdc897b32083.webp",
        "width": 1920,
        "height": 1217
      },
      "title": "Apartment",
      "description": "Contemporary apartment kitchen with stainless appliances and light speckled countertops.",
      "link": "false",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertop.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/67568d2596520f2f922aa3f4a9ca0791-1920w.webp"
    },
    {
      "id": "custom_61ee2293-d627-46a9-8e43-79c6534e6cd1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-d63d-759a-9e7d-cf5edc9d2de0.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and TV stand.",
        "public_id": "019fd925-d63d-759a-9e7d-cf5edc9d2de0",
        "storage_key": "property/6767906449166329/019fd925-d63d-759a-9e7d-cf5edc9d2de0.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment living room with neutral tones, beige sectional, round coffee table, rug, and white patterned console.",
      "link": "false",
      "alt_text": "Bright apartment living room with a beige sectional, round coffee table, and a white patterned console.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/b1cd5cdf2db0c09776315cbd0e11d938-1920w.webp"
    },
    {
      "id": "custom_0552a0a3-8ca4-4d04-a708-76f76b357ef1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-def3-77f9-a4a1-f662321af349.webp",
      "image_media": {
        "alt_text": "Staircase and kitchen island with wine bottle and glasses.",
        "public_id": "019fd925-def3-77f9-a4a1-f662321af349",
        "storage_key": "property/6767906449166329/019fd925-def3-77f9-a4a1-f662321af349.webp",
        "width": 1920,
        "height": 1315
      },
      "title": "Apartment",
      "description": "Bright apartment interior with a staircase, granite counter island, and a view into the living area.",
      "link": "false",
      "alt_text": "Interior of an apartment showing a staircase beside a granite-topped island and a wall painting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/81e46b8acd19f9f0848239348b774043-1920w.jpg"
    },
    {
      "id": "custom_2f00bced-26e2-4cb6-9b3e-276f50af3d20",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-e025-7641-b2fc-a2b5925af406.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed, closet, desk, and dresser.",
        "public_id": "019fd925-e025-7641-b2fc-a2b5925af406",
        "storage_key": "property/6767906449166329/019fd925-e025-7641-b2fc-a2b5925af406.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright, neutral bedroom interior with closet, dresser, and workspace, showcasing a comfortable apartment.",
      "link": "false",
      "alt_text": "Bedroom with bed, dresser, desk, ceiling fan, and open closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/a993721bb0ba8e72e3cf61cc4e131ecc-1920w.jpg"
    },
    {
      "id": "custom_71f3b69c-c54f-4880-9502-f601133d963e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-e23d-760b-83f8-2a54ccf5187b.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and window.",
        "public_id": "019fd925-e23d-760b-83f8-2a54ccf5187b",
        "storage_key": "property/6767906449166329/019fd925-e23d-760b-83f8-2a54ccf5187b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Modern apartment bedroom in neutral tones with a woven headboard, dresser, and ample natural light.",
      "link": "false",
      "alt_text": "Bedroom interior with a queen bed, woven headboard, dresser, window with blinds, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/9a7bcda90960e8cb42a70780a1ce021f-1920w.jpg"
    },
    {
      "id": "custom_5ffb1e9d-0dc6-45c4-bb69-e4d859ffea05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-e2c3-7134-aef9-386c576f81ee.webp",
      "image_media": {
        "alt_text": "Modern bedroom with a queen-size bed, dresser, and closet.",
        "public_id": "019fd925-e2c3-7134-aef9-386c576f81ee",
        "storage_key": "property/6767906449166329/019fd925-e2c3-7134-aef9-386c576f81ee.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Compact apartment bedroom featuring an open closet, a light wood dresser, black wall shelves, a padded bench, and a ceiling fan.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with an open closet, a light wood dresser, wall-mounted shelves, a bench, and a ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/b6854cd44682b5356c320b6d82984be9-1920w.webp"
    },
    {
      "id": "custom_665e048b-f80b-4dda-9413-75f0f1161a22",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-eb59-71da-a591-5c55815bb053.webp",
      "image_media": {
        "alt_text": "A staged bedroom with a queen-sized bed, nightstand, ceiling fan, and artwork on the wall.",
        "public_id": "019fd925-eb59-71da-a591-5c55815bb053",
        "storage_key": "property/6767906449166329/019fd925-eb59-71da-a591-5c55815bb053.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Bedroom with a neutral palette, a bed, two windows with white blinds, and a white closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/9a447eaaed9b2b89224e6f3458b731e1-1920w.webp"
    },
    {
      "id": "custom_d63361f3-bb5e-4e31-a2b4-955704a9edf1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-ece5-753c-8082-f4bae1268052.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white vanity, sink, chrome faucet, and toilet.",
        "public_id": "019fd925-ece5-753c-8082-f4bae1268052",
        "storage_key": "property/6767906449166329/019fd925-ece5-753c-8082-f4bae1268052.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with a tub/shower, white vanity, and organized shelving by the sink.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub/shower, white tiled walls, dark shower curtain, toilet, and white vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/41e2188f0acefd2eb635a7b17ff4a64b-1920w.jpg"
    },
    {
      "id": "custom_f7b25b8e-445f-485a-aab6-b3902b9c60ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-ed71-7026-b383-0615a4966a93.webp",
      "image_media": {
        "alt_text": "Living room with a coffee table, sofa, and bar stools.",
        "public_id": "019fd925-ed71-7026-b383-0615a4966a93",
        "storage_key": "property/6767906449166329/019fd925-ed71-7026-b383-0615a4966a93.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Contemporary living space in a multifamily unit with neutral decor and stylish furnishings.",
      "link": "false",
      "alt_text": "Neutral-toned living room in an apartment with a beige sofa, round coffee table, and gray rug.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/aae25b4de02482e42c4e2a69974d6c68-1920w.webp"
    },
    {
      "id": "custom_31bb337f-f4b2-4bf7-a85a-2b4945e8276c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-ee45-7286-b4ba-cda0f240c2ea.webp",
      "image_media": {
        "alt_text": "Balcony view with seating area and buildings in the background.",
        "public_id": "019fd925-ee45-7286-b4ba-cda0f240c2ea",
        "storage_key": "property/6767906449166329/019fd925-ee45-7286-b4ba-cda0f240c2ea.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Apartment",
      "description": "Featured",
      "link": "false",
      "alt_text": "Balcony with white railing and wicker chairs, overlooking a tree-lined apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/43098366b8ebfd0601493f907e34dbd4-1920w.jpg"
    },
    {
      "id": "custom_f7935e2b-4f47-454d-93c1-35fb0cabb8d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-f7b0-77dc-8840-4d0dfb72c77b.webp",
      "image_media": {
        "alt_text": "Sign for a dog park with the text 'Welcome to the Dog Park' and a paw print logo.",
        "public_id": "019fd925-f7b0-77dc-8840-4d0dfb72c77b",
        "storage_key": "property/6767906449166329/019fd925-f7b0-77dc-8840-4d0dfb72c77b.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Dog park sign at a multifamily community, featuring a blue paw print logo and owner rules by a fenced yard.",
      "link": "false",
      "alt_text": "Circular dog park sign with blue paw print and orange border beside a fence.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/5eed9969020c4a78a0cbe09f73d213fd-1920w.webp"
    },
    {
      "id": "custom_0b80113e-4e56-4da1-8707-5279661b0a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-f8ef-703e-b540-799f4edc0a8c.webp",
      "image_media": {
        "alt_text": "Children's playground with slides and climbing structures.",
        "public_id": "019fd925-f8ef-703e-b540-799f4edc0a8c",
        "storage_key": "property/6767906449166329/019fd925-f8ef-703e-b540-799f4edc0a8c.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Outdoor children's playground at the property’s community area, featuring green climbing structures and dual beige slides.",
      "link": "false",
      "alt_text": "Outdoor playground equipment with green slides in a grassy common area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/6e93fffacc6767020087f35da47784d8-1920w.jpg"
    },
    {
      "id": "custom_4cdd5829-f0ef-42cc-a512-308aa97f421c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-f9d1-74b9-8934-754b46acb59e.webp",
      "image_media": {
        "alt_text": "Townhouse style apartment buildings with manicured lawns and trees.",
        "public_id": "019fd925-f9d1-74b9-8934-754b46acb59e",
        "storage_key": "property/6767906449166329/019fd925-f9d1-74b9-8934-754b46acb59e.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment building with lawn, sidewalk, and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/d5f4ef016214a8363f2bfb670309da7e-1920w.webp"
    },
    {
      "id": "custom_cc44e47f-52fb-4695-8c89-0c008e30ba1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-fbff-7799-9983-3fd73b7a8698.webp",
      "image_media": {
        "alt_text": "Mariner's Pointe Leasing Center and apartment buildings with landscaping",
        "public_id": "019fd925-fbff-7799-9983-3fd73b7a8698",
        "storage_key": "property/6767906449166329/019fd925-fbff-7799-9983-3fd73b7a8698.webp",
        "width": 1920,
        "height": 1282
      },
      "title": "Community",
      "description": "Featured",
      "link": "false",
      "alt_text": "Exterior view of a brick apartment community with a blue leasing center sign and landscaped walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://lirp.cdn-website.com/3ae5132b/dms3rep/multi/opt/5767906449162442/6767906449166329/aa3ebae686d1e2fbe5df1e0aac0dd435-1920w.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_1e0b755a-4052-4457-9ed6-63171dd5e999",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Sapore Di Mare",
      "poi_type": "Restaurants",
      "poi_address": "504 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Old-school, mom-&-pop eatery offering classic Italian fare, including pizza, pasta & seafood dishes.",
      "poi_long_description": "Old-school, mom-&-pop eatery offering classic Italian fare, including pizza, pasta & seafood dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-441b-73f2-b458-580a35457ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-441b-73f2-b458-580a35457ad3",
        "storage_key": "property/6767906449166329/019fd924-441b-73f2-b458-580a35457ad3.webp",
        "width": 713,
        "height": 710
      },
      "poi_business_url": "http://saporedimare.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13162995833079214946&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sapore-di-mare",
      "poi_latitude": "39.408442",
      "poi_longitude": "-76.34943679999999",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 410-538-8066",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJD4jYihDkx4kRYjOiOvharLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aa623008-7b21-4cf5-8681-748721f12bf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Towne Grill & Pub",
      "poi_type": "Restaurants",
      "poi_address": "1006 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Casual, friendly place for American grub such as wings, plus a bar with beer and wine.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-39e4-76ef-b0c3-a055defe4123.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-39e4-76ef-b0c3-a055defe4123",
        "storage_key": "property/6767906449166329/019fd924-39e4-76ef-b0c3-a055defe4123.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.townegrillandpub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15287928610172243718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "towne-grill--pub",
      "poi_latitude": "39.4211",
      "poi_longitude": "-76.3703647",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 410-538-4665",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-8d93ee2b5105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-8d93ee2b5105",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-8d93ee2b5105.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm1zn-P3jx4kRBg_ZcBKiKdQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cdcdea8f-2d8a-4777-a679-e961e0376d17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "New Chinese Boys",
      "poi_type": "Restaurants",
      "poi_address": "1020 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Casual Chinese eatery serving familiar fare such as sesame chicken and beef and broccoli for dine-in or takeout.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-4387-77cf-8c75-f601be0e64eb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-4387-77cf-8c75-f601be0e64eb",
        "storage_key": "property/6767906449166329/019fd924-4387-77cf-8c75-f601be0e64eb.webp",
        "width": 1280,
        "height": 1261
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14727083512752621574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-chinese-boys",
      "poi_latitude": "39.4206753",
      "poi_longitude": "-76.371188",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 410-679-8878",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJAxm5Albhx4kRBsgha20cYcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ee652262-2a58-4615-beba-5d8003c68aa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Dunkin'",
      "poi_type": "Restaurants",
      "poi_address": "998 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_long_description": "Long-running chain serving signature breakfast items & a variety of coffee drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-4147-741c-8f2e-e7e0bc47c004.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-4147-741c-8f2e-e7e0bc47c004",
        "storage_key": "property/6767906449166329/019fd924-4147-741c-8f2e-e7e0bc47c004.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.dunkindonuts.com/en/md/joppa/998-joppa-farm-rd/351811?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=351811&y_source=1_MTIxMTQyMzctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4256328348450833828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dunkin",
      "poi_latitude": "39.4226414",
      "poi_longitude": "-76.37125809999999",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 410-593-7296",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beb3-73db-9847-db1f6d1b3371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beb3-73db-9847-db1f6d1b3371",
        "storage_key": "property/6767906449166329/019d0268-beb3-73db-9847-db1f6d1b3371.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJlRRJ_P3jx4kRpEXW-BSEETs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b132366b-dbea-42cd-abf5-b8e18eee7e9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Baldwin's Seafood Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "525 Pulaski Hwy, Joppatowne, MD 21085, USA",
      "poi_short_description": "Steamed crabs, fish platters & a Sunday brunch buffet in a down-home, established eatery & bar.",
      "poi_long_description": "Steamed crabs, fish platters & a Sunday brunch buffet in a down-home, established eatery & bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-449b-71ab-bb88-a7afc69ae385.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-449b-71ab-bb88-a7afc69ae385",
        "storage_key": "property/6767906449166329/019fd924-449b-71ab-bb88-a7afc69ae385.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=12564681866720368774&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baldwins-seafood-restaurant",
      "poi_latitude": "39.4283905",
      "poi_longitude": "-76.3568954",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxawXYq7mx4kRhtioVZa3Xq4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6891e022-8688-4614-817b-71a28b5f42aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Mountain Branch Grill & Pub",
      "poi_type": "Restaurants",
      "poi_address": "1827 Mountain Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Set on a golf course, this roomy, upmarket choice offers regional American fare & rustic atmosphere.",
      "poi_long_description": "Set on a golf course, this roomy, upmarket choice offers regional American fare & rustic atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-55ca-70d1-ad57-a99ce8d3c2b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-55ca-70d1-ad57-a99ce8d3c2b1",
        "storage_key": "property/6767906449166329/019fd924-55ca-70d1-ad57-a99ce8d3c2b1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mountainbranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2510916688245525674&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mountain-branch-grill--pub",
      "poi_latitude": "39.4670103",
      "poi_longitude": "-76.3698041",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 410-836-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzRs82tDgx4kRqox5r2yR2CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_66386285-2ee8-4dda-be0a-a8cf3d1ec853",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "La Tolteca",
      "poi_type": "Restaurants",
      "poi_address": "1411 Mountain Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Spacious restaurant whipping up Tex-Mex staples such as burritos, chimichangas and fajitas, plus margaritas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-5869-76ff-b4ab-16647c86c61f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-5869-76ff-b4ab-16647c86c61f",
        "storage_key": "property/6767906449166329/019fd924-5869-76ff-b4ab-16647c86c61f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://latoltecamd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8019729749351631200&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-tolteca",
      "poi_latitude": "39.4392972",
      "poi_longitude": "-76.3450922",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-612-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjQ5WXr_mx4kRYIm8eLfNS28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0bd9f9fb-bb45-4234-8cbc-f491c29adb7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "HipHop Fish & Chicken",
      "poi_type": "Restaurants",
      "poi_address": "1012 Magnolia Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Low-key fast-food chain serving fried seafood & chicken, plus Southern sides & Buffalo wings.",
      "poi_long_description": "Low-key fast-food chain serving fried seafood & chicken, plus Southern sides & Buffalo wings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-59aa-72cb-b6d0-faa976f7d986.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-59aa-72cb-b6d0-faa976f7d986",
        "storage_key": "property/6767906449166329/019fd924-59aa-72cb-b6d0-faa976f7d986.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hiphopfc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17624177482779936366&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hiphop-fish--chicken",
      "poi_latitude": "39.4311632",
      "poi_longitude": "-76.33715839999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 443-484-2250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLwAQ9Lnnx4kRbkaJLwuolfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7526bfab-94c6-4291-8238-57dbe19f9fe5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Fortunato Brothers Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1401 Pulaski Hwy R, Edgewood, MD 21040, USA",
      "poi_short_description": "Casual pizzeria and Italian eatery dishing up traditional pies as well as crab cakes and burgers amid a welcoming setting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-59f1-71bd-9232-db881655cec5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-59f1-71bd-9232-db881655cec5",
        "storage_key": "property/6767906449166329/019fd924-59f1-71bd-9232-db881655cec5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.fortunatobrotherspizza.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=7524896244666760155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fortunato-brothers-pizza",
      "poi_latitude": "39.43266089999999",
      "poi_longitude": "-76.3244454",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-612-1260",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSBXFozmx4kR23sIE0TNbWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_096cfb42-318f-442d-9ff9-a8e3f6a4b0a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Zorba's Pizza & Grill",
      "poi_type": "Restaurants",
      "poi_address": "2000 Pulaski Hwy, Edgewood, MD 21040, USA",
      "poi_short_description": "Casual restaurant serving pizzas and a variety of other dishes, including Greek specialties.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-71f2-7048-bf2f-c199bf3c4e51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-71f2-7048-bf2f-c199bf3c4e51",
        "storage_key": "property/6767906449166329/019fd924-71f2-7048-bf2f-c199bf3c4e51.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.zorbaspizzagrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14646434891575807283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zorbas-pizza--grill",
      "poi_latitude": "39.43618319999999",
      "poi_longitude": "-76.31197279999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 410-676-6300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm2GkCF7mx4kRM01DCu-WQss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_48a8f668-fc8f-46d9-b6de-dc895993fcec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Hilltop Pizza & Subs",
      "poi_type": "Restaurants",
      "poi_address": "1709 Edgewood Rd #2, Edgewood, MD 21040, USA",
      "poi_short_description": "Casual pizzeria serving pies with handmade dough, plus breakfast, sandwiches, pasta, and more.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-63e5-767f-b76a-f034597db2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-63e5-767f-b76a-f034597db2d6",
        "storage_key": "property/6767906449166329/019fd924-63e5-767f-b76a-f034597db2d6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hilltoppizzasubsedgewood.com/?utm_source=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=6859985458119739744&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hilltop-pizza--subs",
      "poi_latitude": "39.4521444",
      "poi_longitude": "-76.3071448",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 410-676-8444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOySxdufnx4kRYImSq22QM18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f634e596-7174-41c9-bea2-2ea14c1b89c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Starbucks",
      "poi_type": "Restaurants",
      "poi_address": "8145-A Honeygo Blvd, Nottingham, MD 21236, USA",
      "poi_short_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_long_description": "Seattle-based coffeehouse chain known for its signature roasts, light bites and WiFi availability.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-6fc3-71bf-9f8c-842a51ffb537.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-6fc3-71bf-9f8c-842a51ffb537",
        "storage_key": "property/6767906449166329/019fd924-6fc3-71bf-9f8c-842a51ffb537.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/15604/",
      "poi_directions_map_url": "https://maps.google.com/?cid=577694213382933659&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks",
      "poi_latitude": "39.3709",
      "poi_longitude": "-76.46444",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 410-931-1056",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beb3-73db-9847-db1f6d1b3371.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beb3-73db-9847-db1f6d1b3371",
        "storage_key": "property/6767906449166329/019d0268-beb3-73db-9847-db1f6d1b3371.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJb6ik9RcIyIkRmwx9idNhBAg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_038f7a31-77e4-45d0-9cde-78645c48a950",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Dew Drop Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "12301 Philadelphia Rd, Kingsville, MD 21087, USA",
      "poi_short_description": "Relaxed eatery featuring burgers and seafood, plus live bands with a spacious deck.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-70a9-763f-99d5-e2e353683085.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-70a9-763f-99d5-e2e353683085",
        "storage_key": "property/6767906449166329/019fd924-70a9-763f-99d5-e2e353683085.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://dewdropbargrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14912421765871319031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dew-drop-bar--grill",
      "poi_latitude": "39.421679",
      "poi_longitude": "-76.38510289999999",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 410-538-3126",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-8d93ee2b5105.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-8d93ee2b5105",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-8d93ee2b5105.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6oGXODjx4kR9zeQL5aQ884",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a1fdb032-164e-4643-92ea-717cd6f1b2c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping",
      "poi_address": "1312 Business Center Way, Edgewood, MD 21040, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-6edd-720e-a897-5edf0071ccd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-6edd-720e-a897-5edf0071ccd6",
        "storage_key": "property/6767906449166329/019fd924-6edd-720e-a897-5edf0071ccd6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://stores.aldi.us/md/edgewood/1312-business-center-way?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=9955919763363982880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "39.4346736",
      "poi_longitude": "-76.32720549999999",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beb2-72a8-9497-6c3a0f0b6036.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beb2-72a8-9497-6c3a0f0b6036",
        "storage_key": "property/6767906449166329/019d0268-beb2-72a8-9497-6c3a0f0b6036.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7x1ECI3mx4kRIO6Zq0aIKoo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d34bdf13-981c-49b6-b72f-3eb7502a2c96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping",
      "poi_address": "1013 Woodbridge Center Way, Edgewood, MD 21040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-a780-735f-b6b5-b58ffbb6d401.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-a780-735f-b6b5-b58ffbb6d401",
        "storage_key": "property/6767906449166329/019fd924-a780-735f-b6b5-b58ffbb6d401.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/edgewood-md-pharmacies/1013-woodbridge-ctr-way-edgewood-md-21040/storeid=4214?WT.mc_id=LS_GOOGLE_RX_4214",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581664492652319937&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.4327832",
      "poi_longitude": "-76.3281937",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-676-6100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c261-7338-8dd7-3a4211816d7d",
        "storage_key": "property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNf2D5I3mx4kRwdTze0gOdk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b73a5f12-71a7-4192-a392-c47cebb41ed4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Redner's Warehouse Markets",
      "poi_type": "Shopping",
      "poi_address": "1002 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Fresh fried chicken and other subs are sold at this supermarket chain that rewards loyalty.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-8ab1-77b0-88a1-7d175ad9377d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-8ab1-77b0-88a1-7d175ad9377d",
        "storage_key": "property/6767906449166329/019fd924-8ab1-77b0-88a1-7d175ad9377d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.rednersmarkets.com/redners-locations.html?",
      "poi_directions_map_url": "https://maps.google.com/?cid=10144225145385160451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redners-warehouse-markets",
      "poi_latitude": "39.4204102",
      "poi_longitude": "-76.3701809",
      "poi_miles_from_property": "0.2 mi",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c267-7501-a30e-7d8aa87ef295",
        "storage_key": "property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJfxES2_3jx4kRA49E-AWHx4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_47df9be1-fae7-4de9-b876-b32eab3819a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Wawa",
      "poi_type": "Shopping",
      "poi_address": "1419 Mountain Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_long_description": "Convenience store chain known for sandwiches & coffee. Many offer fuel & are open 24/7.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-78bc-77f9-a579-b6e3682c38fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-78bc-77f9-a579-b6e3682c38fb",
        "storage_key": "property/6767906449166329/019fd924-78bc-77f9-a579-b6e3682c38fb.webp",
        "width": 500,
        "height": 400
      },
      "poi_business_url": "https://www.wawa.com/locations/0599?utm_source=gmblisting&utm_medium=organic&utm_campaign=locallisting",
      "poi_directions_map_url": "https://maps.google.com/?cid=17268066720618586634&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wawa",
      "poi_latitude": "39.43998759999999",
      "poi_longitude": "-76.3455108",
      "poi_miles_from_property": "2.4 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 410-538-3131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beae-7135-a528-898ffa8301b6",
        "storage_key": "property/6767906449166329/019d0268-beae-7135-a528-898ffa8301b6.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJizxTa5bmx4kRCiI3ODF_pO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9efcd988-8618-4096-a458-b927d7d5f67e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Royal Farms",
      "poi_type": "Shopping",
      "poi_address": "500 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_long_description": "Gas-station & convenience-store chain serving breakfast sandwiches, fried chicken & deli items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-7aab-741b-a80a-5d5738964652.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-7aab-741b-a80a-5d5738964652",
        "storage_key": "property/6767906449166329/019fd924-7aab-741b-a80a-5d5738964652.webp",
        "width": 250,
        "height": 250
      },
      "poi_business_url": "https://www.royalfarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17952527814588406917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "royal-farms",
      "poi_latitude": "39.4080175",
      "poi_longitude": "-76.3491256",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 410-698-0124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26e-709c-87a8-80505b12f4b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26e-709c-87a8-80505b12f4b7",
        "storage_key": "property/6767906449166329/019d0268-c26e-709c-87a8-80505b12f4b7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJt7wj9RDkx4kRhZzcSO4wJPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ae159d27-5c19-4a2c-bc5e-eb4d697d7ef3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Sheetz",
      "poi_type": "Shopping",
      "poi_address": "601 Pulaski Hwy, Joppatowne, MD 21085, USA",
      "poi_short_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_long_description": "Chain offering fuel & familiar convenience goods, including packaged snacks, drinks & takeaway fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-8b18-7766-a948-452b261b61b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-8b18-7766-a948-452b261b61b9",
        "storage_key": "property/6767906449166329/019fd924-8b18-7766-a948-452b261b61b9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://orders.sheetz.com/#/main/location/store/316",
      "poi_directions_map_url": "https://maps.google.com/?cid=11466525277767529362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sheetz",
      "poi_latitude": "39.4286172",
      "poi_longitude": "-76.3547957",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 410-538-3691",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26e-709c-87a8-80505b12f4b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26e-709c-87a8-80505b12f4b7",
        "storage_key": "property/6767906449166329/019d0268-c26e-709c-87a8-80505b12f4b7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ626dTK7mx4kRkvNe5fxHIZ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5677c245-b5f6-4b6e-8c15-b84baf5d7ab8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping",
      "poi_address": "1901 Pulaski Hwy, Edgewood, MD 21040, USA",
      "poi_short_description": "Clean supermarket carrying name-brand items at discount prices, plus organic food.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-995e-70ac-a716-7ca24c137403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-995e-70ac-a716-7ca24c137403",
        "storage_key": "property/6767906449166329/019fd924-995e-70ac-a716-7ca24c137403.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/743?utm_source=extnet&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=6451593030083553628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "39.4341131",
      "poi_longitude": "-76.3158903",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-417-9799",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-beb2-72a8-9497-6c3a0f0b6036.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-beb2-72a8-9497-6c3a0f0b6036",
        "storage_key": "property/6767906449166329/019d0268-beb2-72a8-9497-6c3a0f0b6036.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7y-eF9fnx4kRXCmEya2piFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c54aaa4c-9650-4d49-b84a-12a6e32617a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping",
      "poi_address": "300 Pulaski Hwy, Joppatowne, MD 21085, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-a8cf-766d-bf4f-bd29ff1b1792.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-a8cf-766d-bf4f-bd29ff1b1792",
        "storage_key": "property/6767906449166329/019fd924-a8cf-766d-bf4f-bd29ff1b1792.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-300+pulaski+hwy-joppa-md-21085/id=18946",
      "poi_directions_map_url": "https://maps.google.com/?cid=14170070507458465334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "39.4239522",
      "poi_longitude": "-76.3712051",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 410-538-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo1HwGvjhx4kRNg5N3ww0psQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_765bb444-6d96-4fc9-9794-2cfd8d7fa5eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping",
      "poi_address": "1010 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-93ff-76fa-928e-23dd089fd76d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-93ff-76fa-928e-23dd089fd76d",
        "storage_key": "property/6767906449166329/019fd924-93ff-76fa-928e-23dd089fd76d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/md/joppa/1010-joppa-farm-road?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=16977534378343078359&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "39.4209566",
      "poi_longitude": "-76.3705152",
      "poi_miles_from_property": "0.1 mi",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 410-994-7705",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c267-7501-a30e-7d8aa87ef295",
        "storage_key": "property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6-GM-P3jx4kR1xkf95BRnOs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_70cffca2-82fc-4858-af31-cd4e2c0344b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harbor Freight",
      "poi_type": "Shopping",
      "poi_address": "1901-C, Pulaski Hwy, Edgewood, MD 21040, USA",
      "poi_short_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_long_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-9db2-73a8-a8f1-e7fbb905ab76.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-9db2-73a8-a8f1-e7fbb905ab76",
        "storage_key": "property/6767906449166329/019fd924-9db2-73a8-a8f1-e7fbb905ab76.webp",
        "width": 1280,
        "height": 704
      },
      "poi_business_url": "https://www.harborfreight.com/storelocator/1901-c-pulaski-hwy-edgewood-21040?number=451",
      "poi_directions_map_url": "https://maps.google.com/?cid=11544722831475672495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harbor-freight",
      "poi_latitude": "39.4341597",
      "poi_longitude": "-76.3153785",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 410-671-7192",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c267-7501-a30e-7d8aa87ef295",
        "storage_key": "property/6767906449166329/019d0268-c267-7501-a30e-7d8aa87ef295.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc8vEhGDmx4kRrwVzqD8YN6A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f730f62f-5b10-4a6f-91e4-c7b6248d5f5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Joppatowne Elementary School",
      "poi_type": "Education",
      "poi_address": "407 Trimble Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-aa3f-73cb-bb4e-45977d77ce31.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-aa3f-73cb-bb4e-45977d77ce31",
        "storage_key": "property/6767906449166329/019fd924-aa3f-73cb-bb4e-45977d77ce31.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://joes.ss18.sharpschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1657083624815262386&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joppatowne-elementary-school",
      "poi_latitude": "39.4205414",
      "poi_longitude": "-76.3619768",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 410-612-1546",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJN662parmx4kRsvo69MYk_xY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c12f29a9-96e9-4532-924c-add58f3570ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Magnolia Elementary School",
      "poi_type": "Education",
      "poi_address": "901 Trimble Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://maes.ss18.sharpschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15146525210530629889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-elementary-school",
      "poi_latitude": "39.4111161",
      "poi_longitude": "-76.33180500000002",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-612-1553",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeyXQtSXkx4kRAUkt421EM9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_462ccd4e-4eb1-4c67-82d2-73a7d44dbf4b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Magnolia Middle School",
      "poi_type": "Education",
      "poi_address": "299 Fort Hoyle Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-b033-77ad-88ab-66257868f6ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-b033-77ad-88ab-66257868f6ce",
        "storage_key": "property/6767906449166329/019fd924-b033-77ad-88ab-66257868f6ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.harfordeducation.org/o/mams",
      "poi_directions_map_url": "https://maps.google.com/?cid=824427254289289230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "magnolia-middle-school",
      "poi_latitude": "39.4080852",
      "poi_longitude": "-76.330483",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-612-1525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJielP0zrkx4kRDlAQQzj0cAs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_172d6dfc-68db-4ddc-86c3-ed75dd8ffc44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Joppatowne High School",
      "poi_type": "Education",
      "poi_address": "555 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-b0f2-7465-9071-1ca39c4952b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-b0f2-7465-9071-1ca39c4952b4",
        "storage_key": "property/6767906449166329/019fd924-b0f2-7465-9071-1ca39c4952b4.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3219309788619501775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joppatowne-high-school",
      "poi_latitude": "39.4143512",
      "poi_longitude": "-76.35151479999999",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 410-612-1510",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlxMPOBvkx4kRz3CaNDJJrSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2150fd11-8f50-44b5-a0dc-d717aec45104",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Riverside Elementary School",
      "poi_type": "Education",
      "poi_address": "211 Stillmeadow Dr, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-ba6f-7197-8a8a-e441fc1f1092.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-ba6f-7197-8a8a-e441fc1f1092",
        "storage_key": "property/6767906449166329/019fd924-ba6f-7197-8a8a-e441fc1f1092.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://rves.ss18.sharpschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10878728322070526959&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-elementary-school",
      "poi_latitude": "39.4011714",
      "poi_longitude": "-76.33799909999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 410-612-1560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxTT09T7kx4kR77v-XMUB-ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15fcfe2b-cc94-47c5-8292-23383307d1f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Sterling East-Chesapeake Campus",
      "poi_type": "Education",
      "poi_address": "900 Trimble Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7538602249410122213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sterling-east-chesapeake-campus",
      "poi_latitude": "39.4126401",
      "poi_longitude": "-76.33331439999999",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsxkGISTkx4kR5REN-81-nmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6764aff8-d42d-4895-8503-35f7b3f213c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Trinity Lutheran Christian School",
      "poi_type": "Education",
      "poi_address": "1100 Philadelphia Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-b5f1-72cd-8f62-6af6500111b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-b5f1-72cd-8f62-6af6500111b4",
        "storage_key": "property/6767906449166329/019fd924-b5f1-72cd-8f62-6af6500111b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=6175962078702263444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-lutheran-christian-school",
      "poi_latitude": "39.4401947",
      "poi_longitude": "-76.3398357",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-679-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJR-oDourmx4kRlNxU98lstVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_729f80e4-b2a0-4a36-a903-76c138bb1421",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Good Shepherd Children's Center",
      "poi_type": "Education",
      "poi_address": "622 Joppa Farm Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://holy411.org/childrens-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10791945411716549902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "good-shepherd-childrens-center",
      "poi_latitude": "39.4124851",
      "poi_longitude": "-76.3556191",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 410-679-3390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtQDcJ3vlx4kRDo3FfCyxxJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a9cfd151-2c28-4a14-87c5-5a277fee6e7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford Community College",
      "poi_type": "Education",
      "poi_address": "401 Thomas Run Rd, Bel Air, MD 21015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-c944-7326-be3d-2ace67e0bbd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-c944-7326-be3d-2ace67e0bbd2",
        "storage_key": "property/6767906449166329/019fd924-c944-7326-be3d-2ace67e0bbd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.harford.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264388711695330638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-community-college",
      "poi_latitude": "39.5601692",
      "poi_longitude": "-76.2845403",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 443-412-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3dFcFLrcx4kRTi3pw43cM6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_31d45573-cbb5-468e-a89e-52999a56ac07",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford Technical High School",
      "poi_type": "Education",
      "poi_address": "Amoss Center, 200 Thomas Run Rd, Bel Air, MD 21015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hths.ss18.sharpschool.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3182205225164015270&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-technical-high-school",
      "poi_latitude": "39.5590519",
      "poi_longitude": "-76.2876619",
      "poi_miles_from_property": "13.3 mi",
      "poi_walking_minutes": "5 hours 2 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "+1 410-638-3804",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa6fZYrncx4kRpgZL0Mp2KSw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ff4d5c40-2e25-4556-9805-626bd944b38e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Ripken Stadium",
      "poi_type": "Entertainment",
      "poi_address": "873 Long Dr, Aberdeen, MD 21001, USA",
      "poi_short_description": "Home base of the Aberdeen IronBirds hosts local events, youth sports leagues & seasonal festivities.",
      "poi_long_description": "Home base of the Aberdeen IronBirds hosts local events, youth sports leagues & seasonal festivities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-c6f5-70db-be10-31df61488df7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-c6f5-70db-be10-31df61488df7",
        "storage_key": "property/6767906449166329/019fd924-c6f5-70db-be10-31df61488df7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.milb.com/aberdeen",
      "poi_directions_map_url": "https://maps.google.com/?cid=15562799755699040203&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ripken-stadium",
      "poi_latitude": "39.5308555",
      "poi_longitude": "-76.18574679999999",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 47 mins",
      "poi_biking_minutes": "1 hour 24 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 410-297-9292",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo7OwlNDDx4kRyy_6LOwr-tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_800e5e13-ca18-430b-a7d4-d10d93311096",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Havre De Grace Decoy Museum",
      "poi_type": "Entertainment",
      "poi_address": "215 Giles St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Venue showcasing working duck decoys along with folk & fine art models plus tours & demonstrations.",
      "poi_long_description": "Venue showcasing working duck decoys along with folk & fine art models plus tours & demonstrations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-c04f-73d4-b1bf-5eb95d99f02f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-c04f-73d4-b1bf-5eb95d99f02f",
        "storage_key": "property/6767906449166329/019fd924-c04f-73d4-b1bf-5eb95d99f02f.webp",
        "width": 1280,
        "height": 794
      },
      "poi_business_url": "http://www.decoymuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9485027869887035461&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "havre-de-grace-decoy-museum",
      "poi_latitude": "39.5398431",
      "poi_longitude": "-76.0868642",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 38 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 410-939-3739",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5b1-7600-b975-10d5c0e47741",
        "storage_key": "property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQzgB_Ve_x4kRRfhLBZiWoYM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40d7d357-2b6b-4499-9117-25ace2fe2bc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Susquehanna State Park",
      "poi_type": "Entertainment",
      "poi_address": "4118 Wilkinson Rd, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_long_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-d6a4-76dd-bbdf-50428feb31c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-d6a4-76dd-bbdf-50428feb31c7",
        "storage_key": "property/6767906449166329/019fd924-d6a4-76dd-bbdf-50428feb31c7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/central/susquehanna.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1816830562212225339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susquehanna-state-park",
      "poi_latitude": "39.60630949999999",
      "poi_longitude": "-76.16026459999999",
      "poi_miles_from_property": "19.8 mi",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 410-557-7994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R92Tl7Gx4kRO6G7NcWtNhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f2fc15bc-c451-4cd2-95c2-2169691004fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Steppingstone Farm Museum",
      "poi_type": "Entertainment",
      "poi_address": "461 Quaker Bottom Rd, Havre De Grace, MD 21078, USA",
      "poi_short_description": "History exhibits & buildings including a 1772 farmhouse, blacksmith & 1900-era general store.",
      "poi_long_description": "History exhibits & buildings including a 1772 farmhouse, blacksmith & 1900-era general store.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-d721-7379-b8c2-cdfb0d46a394.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-d721-7379-b8c2-cdfb0d46a394",
        "storage_key": "property/6767906449166329/019fd924-d721-7379-b8c2-cdfb0d46a394.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.steppingstonemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5922993921952948784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "steppingstone-farm-museum",
      "poi_latitude": "39.6018227",
      "poi_longitude": "-76.1398516",
      "poi_miles_from_property": "20.6 mi",
      "poi_walking_minutes": "7 hours 36 mins",
      "poi_biking_minutes": "1 hour 51 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 410-939-2299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5b1-7600-b975-10d5c0e47741",
        "storage_key": "property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQRzB0F7Gx4kRMKLNNJezMlI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_396e5ab8-8e65-44e4-98e9-4ce57a865f90",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Lock House Museum",
      "poi_type": "Entertainment",
      "poi_address": "817 Conesteo St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Riverfront museum in an 1840s house focusing on the history of canals & how they worked.",
      "poi_long_description": "Riverfront museum in an 1840s house focusing on the history of canals & how they worked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-d8bb-7559-a0c7-bf8ad8789d30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-d8bb-7559-a0c7-bf8ad8789d30",
        "storage_key": "property/6767906449166329/019fd924-d8bb-7559-a0c7-bf8ad8789d30.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thelockhousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7619861136512362792&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lock-house-museum",
      "poi_latitude": "39.556162",
      "poi_longitude": "-76.0934482",
      "poi_miles_from_property": "18.2 mi",
      "poi_walking_minutes": "6 hours 42 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 410-939-5780",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5b1-7600-b975-10d5c0e47741",
        "storage_key": "property/6767906449166329/019d0268-c5b1-7600-b975-10d5c0e47741.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyWPylPHx4kRKKmf91Qvv2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a7d35c8-f631-416a-af55-7804febf86ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Friends-Concord Point Lighthouse",
      "poi_type": "Entertainment",
      "poi_address": "700 Concord St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Restored 1827 lighthouse with historical exhibits, educational tours & vast ocean views.",
      "poi_long_description": "Restored 1827 lighthouse with historical exhibits, educational tours & vast ocean views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-e8ed-738e-9ed3-3eac1ca80174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-e8ed-738e-9ed3-3eac1ca80174",
        "storage_key": "property/6767906449166329/019fd924-e8ed-738e-9ed3-3eac1ca80174.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.concordpointlighthouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15533846642070003923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-concord-point-lighthouse",
      "poi_latitude": "39.5406924",
      "poi_longitude": "-76.08475829999999",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 410-939-3213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxZ34Fe_x4kR0yD6FzhPk9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_40305aee-17aa-4581-bccc-9d26aaebf307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Cultural Center at the Opera House",
      "poi_type": "Entertainment",
      "poi_address": "121 N Union Ave, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Concerts, plays, and other productions are staged at this venue.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-e69c-70fc-b5fa-4c1d5a2febb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-e69c-70fc-b5fa-4c1d5a2febb5",
        "storage_key": "property/6767906449166329/019fd924-e69c-70fc-b5fa-4c1d5a2febb5.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://hdgoperahouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435942557182062842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cultural-center-at-the-opera-house",
      "poi_latitude": "39.5485001",
      "poi_longitude": "-76.0912972",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 443-502-2005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs2q_gavAx4kR-vA3uXbq05A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a4703b5-d00b-4dfb-a4af-86f0233b5b81",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "The State Havre de Grace",
      "poi_type": "Entertainment",
      "poi_address": "325 St John St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Down-to-earth venue featuring live music, wrestling and shows of various types, along with food and drinks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-ee1e-7174-a336-b731e510f415.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-ee1e-7174-a336-b731e510f415",
        "storage_key": "property/6767906449166329/019fd924-ee1e-7174-a336-b731e510f415.webp",
        "width": 1280,
        "height": 899
      },
      "poi_business_url": "https://www.thestatehavredegrace.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4108713430468741606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-state-havre-de-grace",
      "poi_latitude": "39.5505916",
      "poi_longitude": "-76.08999639999999",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 44 mins",
      "poi_biking_minutes": "1 hour 29 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 443-608-0312",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH-OHK_vBx4kR5kn3mhgVBTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7371c8ef-1d03-4eb0-8278-742930c5d5ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Ladew Topiary Gardens",
      "poi_type": "Entertainment",
      "poi_address": "3535 Jarrettsville Pike, Monkton, MD 21111, USA",
      "poi_short_description": "A historic mansion, formal gardens with 22 \"rooms\" & a nature trail available to tour & explore.",
      "poi_long_description": "A historic mansion, formal gardens with 22 \"rooms\" & a nature trail available to tour & explore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-f413-7637-9e62-a969664ca939.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-f413-7637-9e62-a969664ca939",
        "storage_key": "property/6767906449166329/019fd924-f413-7637-9e62-a969664ca939.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ladewgardens.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=79492983802076143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ladew-topiary-gardens",
      "poi_latitude": "39.58034",
      "poi_longitude": "-76.5145999",
      "poi_miles_from_property": "15.8 mi",
      "poi_walking_minutes": "5 hours 59 mins",
      "poi_biking_minutes": "1 hour 36 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 410-557-9570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-0dZkZ0yIkR75uolXJqGgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f481fbcf-848f-4275-a019-fee4b555e499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Havre De Grace Visitor Center",
      "poi_type": "Entertainment",
      "poi_address": "203 N Washington St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Free tourist information center providing maps and other resources to visitors.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-0357-763e-b3c7-389edf8b42bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-0357-763e-b3c7-389edf8b42bd",
        "storage_key": "property/6767906449166329/019fd925-0357-763e-b3c7-389edf8b42bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hdgtourism.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3235454698389782142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "havre-de-grace-visitor-center",
      "poi_latitude": "39.5488986",
      "poi_longitude": "-76.0896564",
      "poi_miles_from_property": "18.1 mi",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "27 mins",
      "poi_business_phone": "+1 410-939-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxGPeKvAx4kRfj5k8Oek5iw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42926911-9627-4759-b33a-211eb6c912e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "MedStar Franklin Square Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9000 Franklin Square Dr, Baltimore, MD 21237, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-f4d6-75b9-bf36-d8afc89b2a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-f4d6-75b9-bf36-d8afc89b2a0a",
        "storage_key": "property/6767906449166329/019fd924-f4d6-75b9-bf36-d8afc89b2a0a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.medstarhealth.org/locations/medstar-franklin-square-medical-center?utm_campaign=mhs_citations&utm_medium=listing&utm_source=citation_management&utm_term=hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=639733005649942574&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "medstar-franklin-square-medical-center",
      "poi_latitude": "39.3515318",
      "poi_longitude": "-76.47826599999999",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 443-777-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5d3-70a7-a996-6ff7a81dac63",
        "storage_key": "property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJi94w0d8HyIkRLpjbeMfJ4Ag",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d84be716-692e-4ca5-9493-34e2b39e54d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Patient First Primary and Urgent Care - White Marsh",
      "poi_type": "Health and Wellness",
      "poi_address": "4924 Campbell Blvd Suite 125, Baltimore, MD 21236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-f93f-7054-b868-b451de754d21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-f93f-7054-b868-b451de754d21",
        "storage_key": "property/6767906449166329/019fd924-f93f-7054-b868-b451de754d21.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.patientfirst.com/locations/baltimore/white-marsh?utm_source=local&utm_medium=organic&utm_campaign=gbp&y_source=1_NTI1NTU2NDktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=16855208722583163903&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patient-first-primary-and-urgent-care---white-marsh",
      "poi_latitude": "39.3755412",
      "poi_longitude": "-76.45895279999999",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 443-461-1997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ36BpIiEIyIkR_5OizAe76ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_47851f12-2432-42c4-aa9d-fcfdd8ee9343",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "University of Maryland Urgent Care - Forest Hill (Formerly ChoiceOne)",
      "poi_type": "Health and Wellness",
      "poi_address": "1528 Rock Spring Rd #100, Forest Hill, MD 21050, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-017a-765b-988d-691ab7d5425a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-017a-765b-988d-691ab7d5425a",
        "storage_key": "property/6767906449166329/019fd925-017a-765b-988d-691ab7d5425a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.umms.org/health-services/urgent-care/locations/forest-hill?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=12391171273726546180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-maryland-urgent-care---forest-hill-formerly-choiceone",
      "poi_latitude": "39.561015",
      "poi_longitude": "-76.3736315",
      "poi_miles_from_property": "11.9 mi",
      "poi_walking_minutes": "4 hours 33 mins",
      "poi_biking_minutes": "1 hour 19 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 443-776-1131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQdOTvJnex4kRBNF-SZ9I9qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_006524b8-228e-4b2a-becd-4486012190c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "300 Pulaski Hwy, Joppatowne, MD 21085, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-02e1-77e6-bdc3-c1de699d5894.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-02e1-77e6-bdc3-c1de699d5894",
        "storage_key": "property/6767906449166329/019fd925-02e1-77e6-bdc3-c1de699d5894.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-300+pulaski+hwy-joppa-md-21085/id=18946",
      "poi_directions_map_url": "https://maps.google.com/?cid=10916995725196880428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "39.4239836",
      "poi_longitude": "-76.3711986",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 410-538-5124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c261-7338-8dd7-3a4211816d7d",
        "storage_key": "property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy5nObnfhx4kRLGrRdsX1gJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a64d452-af10-4976-b565-f5acfa4bd860",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "403 Constant Friendship Blvd, Abingdon, MD 21009, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-0534-757a-85bf-6c394f3e055b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-0534-757a-85bf-6c394f3e055b",
        "storage_key": "property/6767906449166329/019fd925-0534-757a-85bf-6c394f3e055b.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/abingdon-md-pharmacies/403-constant-friendship-blvd-abingdon-md-21009/storeid=16991?WT.mc_id=LS_GOOGLE_RX_16991",
      "poi_directions_map_url": "https://maps.google.com/?cid=14527498079131336325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "39.4597298",
      "poi_longitude": "-76.3166881",
      "poi_miles_from_property": "8.0 mi",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-670-9001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c261-7338-8dd7-3a4211816d7d",
        "storage_key": "property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbf-Qaqrnx4kRhf7KcYgKnMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f68336e5-67fd-441a-811e-76a10b81ed36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "401 Constant Friendship Blvd, Abingdon, MD 21009, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-0ba7-720e-ba7f-a8a9435dff8b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-0ba7-720e-ba7f-a8a9435dff8b",
        "storage_key": "property/6767906449166329/019fd925-0ba7-720e-ba7f-a8a9435dff8b.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2009-abingdon-md/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=3198919329021351671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "39.4621422",
      "poi_longitude": "-76.3148039",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 410-569-9406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c261-7338-8dd7-3a4211816d7d",
        "storage_key": "property/6767906449166329/019d0268-c261-7338-8dd7-3a4211816d7d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuapSnKnnx4kR99ZyXy7YZCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a6e878d-17b9-489b-b01f-8c2b65205961",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Everlasting Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1809 Fashion Ct #107, Joppatowne, MD 21085, USA",
      "poi_short_description": "Friendly, community-focused gym offering CrossFit programming, personal training and nutrition coaching, plus a sauna.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-0eaf-7427-8b94-b1c8d40259f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-0eaf-7427-8b94-b1c8d40259f1",
        "storage_key": "property/6767906449166329/019fd925-0eaf-7427-8b94-b1c8d40259f1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://crossfiteverlasting.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18014920269737824372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "everlasting-fitness",
      "poi_latitude": "39.4436061",
      "poi_longitude": "-76.3204094",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 443-402-3406",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhWROD3bex4kRdBC1xonaAfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_62f3abe6-f543-47bf-99c0-56d62e6b6175",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3442 Emmorton Rd, Abingdon, MD 21009, USA",
      "poi_short_description": "Chain gym offering tanning services, plus massage chairs and hydromassage in a clean space.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-0f58-717c-a738-519fafaa6a63.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-0f58-717c-a738-519fafaa6a63",
        "storage_key": "property/6767906449166329/019fd925-0f58-717c-a738-519fafaa6a63.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/abingdon-md?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=7160008767050909440&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "39.467392",
      "poi_longitude": "-76.3132538",
      "poi_miles_from_property": "7.9 mi",
      "poi_walking_minutes": "2 hours 58 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 410-809-2593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqT22aabnx4kRAIfAzAl2XWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_af6e1c36-a664-4751-b99f-7ea1851214f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "The Ward Y in Abingdon",
      "poi_type": "Health and Wellness",
      "poi_address": "101 Walter Ward Blvd, Abingdon, MD 21009, USA",
      "poi_short_description": "Nonprofit, family-friendly gym with a pool, plus basketball courts and exercise classes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-11cb-72be-9f75-1b9d2ae2dcda.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-11cb-72be-9f75-1b9d2ae2dcda",
        "storage_key": "property/6767906449166329/019fd925-11cb-72be-9f75-1b9d2ae2dcda.webp",
        "width": 1280,
        "height": 777
      },
      "poi_business_url": "https://ymaryland.org/locations/wardy",
      "poi_directions_map_url": "https://maps.google.com/?cid=15624316243120240388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ward-y-in-abingdon",
      "poi_latitude": "39.4651901",
      "poi_longitude": "-76.3065013",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-679-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw9XN-a_nx4kRBDeMide41Ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5a194205-47a0-4d20-a879-93055cfc3813",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "634 Marketplace Dr, Bel Air, MD 21014, USA",
      "poi_short_description": "Pilates studio offering group reformer fusion classes for all ages and fitness levels.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-15ec-7139-a9c7-56d977b7a184.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-15ec-7139-a9c7-56d977b7a184",
        "storage_key": "property/6767906449166329/019fd925-15ec-7139-a9c7-56d977b7a184.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://clubpilates.com/belair/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=12315633480160155831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "39.523196",
      "poi_longitude": "-76.35308669999999",
      "poi_miles_from_property": "9.2 mi",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 410-994-8883",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJhUkmFqPdx4kRt5jaMGbr6ao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_916a712d-4379-4d19-a800-34c556a80e6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Mariner Point Park",
      "poi_type": "Recreation",
      "poi_address": "100 Kearney Dr, Joppatowne, MD 21085, USA",
      "poi_short_description": "Lakeside, playground-dotted park with picnic areas and trails for birds and squirrels along with fishing docks and a marina.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-17bd-755f-9d17-39ed99cceded.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-17bd-755f-9d17-39ed99cceded",
        "storage_key": "property/6767906449166329/019fd925-17bd-755f-9d17-39ed99cceded.webp",
        "width": 555,
        "height": 740
      },
      "poi_business_url": "https://www.visitharford.com/listing/mariner-point-park/225/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11514279226904403437&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mariner-point-park",
      "poi_latitude": "39.4000089",
      "poi_longitude": "-76.3499806",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 410-612-1608",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJBf9gK23kx4kR7d1LnPPvyp8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_42f597cc-fc84-4964-a330-60a278fdcacf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Copenhaver Park",
      "poi_type": "Recreation",
      "poi_address": "Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-5b32-70fb-acd0-b4df302b7ed2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-5b32-70fb-acd0-b4df302b7ed2",
        "storage_key": "property/6767906449166329/019fd925-5b32-70fb-acd0-b4df302b7ed2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7520001791715998606&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "copenhaver-park",
      "poi_latitude": "39.4118721",
      "poi_longitude": "-76.34147779999999",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVkBjkx4kRjnuIcclpXGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c4e5daf-2712-4e9f-bcd5-bd4f16b355b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Trimble Road & Foster Branch Road",
      "poi_type": "Recreation",
      "poi_address": "Trimble Rd & Foster Branch Rd, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?q=Trimble+Rd+%26+Foster+Branch+Rd,+Joppatowne,+MD+21085,+USA&ftid=0x89c7e4190c3801a7:0x1c1285211d543696&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trimble-road--foster-branch-road",
      "poi_latitude": "39.41188",
      "poi_longitude": "-76.34461010000001",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "EjhUcmltYmxlIFJkICYgRm9zdGVyIEJyYW5jaCBSZCwgSm9wcGF0b3duZSwgTUQgMjEwODUsIFVTQSJmImQKFAoSCacBOAwZ5MeJEZY2VB0hhRIcEhQKEgmnATgMGeTHiRGWNlQdIYUSHBoUChIJ5WwSdifkx4kRislEnYi-zL4aFAoSCVPpK9Yb5MeJEa2uM9H5vxnYIgoNkMZ9FxWrvH7S",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23f9cbdb-78ac-4dd1-ade2-eb0d601c7be8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "North Bay Marina",
      "poi_type": "Recreation",
      "poi_address": "510 Riviera Dr, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-327c-73af-8252-e9a478ca724f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-327c-73af-8252-e9a478ca724f",
        "storage_key": "property/6767906449166329/019fd925-327c-73af-8252-e9a478ca724f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.northbaymarinamd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8856964911148087519&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-bay-marina",
      "poi_latitude": "39.407079",
      "poi_longitude": "-76.35066359999999",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 410-888-2628",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4ZmrAN7lx4kR37gUFalC6no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_41de5040-436c-41d1-a8a8-78cda407f625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Anita C Leight Estuary Center",
      "poi_type": "Recreation",
      "poi_address": "700 Otter Point Rd, Abingdon, MD 21009, USA",
      "poi_short_description": "Recreation area with walking trails, a pier, and wildlife, including box turtles.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-2dcf-7119-a36d-883456b459e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-2dcf-7119-a36d-883456b459e1",
        "storage_key": "property/6767906449166329/019fd925-2dcf-7119-a36d-883456b459e1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.otterpointcreek.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7594391527238285204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "anita-c-leight-estuary-center",
      "poi_latitude": "39.4498886",
      "poi_longitude": "-76.268677",
      "poi_miles_from_property": "6.8 mi",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 410-612-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb5h444Dox4kRlDdGctuyZGk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a001e466-bc91-41e3-a160-346650a16d14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Susquehanna State Park",
      "poi_type": "Recreation",
      "poi_address": "4118 Wilkinson Rd, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_long_description": "Rocky, forested venue, featuring a working grist mill, boating, fishing & mountain bike trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-d6a4-76dd-bbdf-50428feb31c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-d6a4-76dd-bbdf-50428feb31c7",
        "storage_key": "property/6767906449166329/019fd924-d6a4-76dd-bbdf-50428feb31c7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://dnr.maryland.gov/publiclands/Pages/central/susquehanna.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=1816830562212225339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "susquehanna-state-park",
      "poi_latitude": "39.60630949999999",
      "poi_longitude": "-76.16026459999999",
      "poi_miles_from_property": "19.8 mi",
      "poi_walking_minutes": "7 hours 21 mins",
      "poi_biking_minutes": "1 hour 56 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 410-557-7994",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2R92Tl7Gx4kRO6G7NcWtNhk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_3ae0f454-13c3-4788-aae2-18e7a729c7d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Friends-Concord Point Lighthouse",
      "poi_type": "Recreation",
      "poi_address": "700 Concord St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Restored 1827 lighthouse with historical exhibits, educational tours & vast ocean views.",
      "poi_long_description": "Restored 1827 lighthouse with historical exhibits, educational tours & vast ocean views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-e8ed-738e-9ed3-3eac1ca80174.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-e8ed-738e-9ed3-3eac1ca80174",
        "storage_key": "property/6767906449166329/019fd924-e8ed-738e-9ed3-3eac1ca80174.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.concordpointlighthouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15533846642070003923&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-concord-point-lighthouse",
      "poi_latitude": "39.5406924",
      "poi_longitude": "-76.08475829999999",
      "poi_miles_from_property": "18.3 mi",
      "poi_walking_minutes": "6 hours 43 mins",
      "poi_biking_minutes": "1 hour 28 mins",
      "poi_driving_minutes": "31 mins",
      "poi_business_phone": "+1 410-939-3213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPxZ34Fe_x4kR0yD6FzhPk9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_037b3c6a-448e-4202-b3b0-10111afc6a04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Millard Tydings Memorial Park",
      "poi_type": "Recreation",
      "poi_address": "908 S Washington St, Havre De Grace, MD 21078, USA",
      "poi_short_description": "Nature area overlooking the river & yacht basin with picnic areas, a pavilion & a playground.",
      "poi_long_description": "Nature area overlooking the river & yacht basin with picnic areas, a pavilion & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-3250-74b9-ad61-cd7eabcd3285.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-3250-74b9-ad61-cd7eabcd3285",
        "storage_key": "property/6767906449166329/019fd925-3250-74b9-ad61-cd7eabcd3285.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=7174319268813209728&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millard-tydings-memorial-park",
      "poi_latitude": "39.5385353",
      "poi_longitude": "-76.0895886",
      "poi_miles_from_property": "18.0 mi",
      "poi_walking_minutes": "6 hours 36 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 410-939-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJn0ktiKbAx4kRgADaIl1NkGM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4894913e-f96c-4d59-bc8b-5a4dee6f2c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Forest Greens Lake Preserve",
      "poi_type": "Recreation",
      "poi_address": "2001-2199 Gulf Dr, Aberdeen, MD 21001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-42b3-737e-b298-02acb0d58c0c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-42b3-737e-b298-02acb0d58c0c",
        "storage_key": "property/6767906449166329/019fd925-42b3-737e-b298-02acb0d58c0c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=8650993850282859671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "forest-greens-lake-preserve",
      "poi_latitude": "39.4468108",
      "poi_longitude": "-76.2282412",
      "poi_miles_from_property": "13.2 mi",
      "poi_walking_minutes": "4 hours 50 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJgxCOmVXox4kRl9wyaBKBDng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_754b5389-b25d-4e5c-9d1f-fbe288c52e12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Marshy Point Nature Center",
      "poi_type": "Recreation",
      "poi_address": "7130 Marshy Point Rd, Middle River, MD 21220, USA",
      "poi_short_description": "Nature center with trails exhibiting native animals, plus maple syrup tasting.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-483e-703d-98ae-175a5944c7fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-483e-703d-98ae-175a5944c7fa",
        "storage_key": "property/6767906449166329/019fd925-483e-703d-98ae-175a5944c7fa.webp",
        "width": 1280,
        "height": 873
      },
      "poi_business_url": "http://www.marshypoint.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4839198688543066886&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshy-point-nature-center",
      "poi_latitude": "39.34967380000001",
      "poi_longitude": "-76.37460279999999",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 52 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 410-887-2817",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5ac-70fd-93aa-93eb6ff19b3b",
        "storage_key": "property/6767906449166329/019d0268-c5ac-70fd-93aa-93eb6ff19b3b.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDVRAf1Pjx4kRBkslbJFJKEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4aeebe53-c4b7-4888-8d49-aa2c19f635ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Joppa Cheyenne Park & Ride",
      "poi_type": "Transportation",
      "poi_address": "Old Mountain Rd N, Joppatowne, MD 21085, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://roads.maryland.gov/mdotsha/pages/index.aspx?PageId=248",
      "poi_directions_map_url": "https://maps.google.com/?cid=7810667857811817883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joppa-cheyenne-park--ride",
      "poi_latitude": "39.4799106",
      "poi_longitude": "-76.38545979999999",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c93f-73e8-8522-77b19e4197b6",
        "storage_key": "property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJbwbWJ8Lgx4kRm0VvswgRZWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3bf651a-92a7-4578-b267-3b63a4f1476b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Edgewood",
      "poi_type": "Transportation",
      "poi_address": "2127 Old Edgewood Rd, Edgewood, MD 21040, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-3c20-7138-a64e-f92d8ff723db.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-3c20-7138-a64e-f92d8ff723db",
        "storage_key": "property/6767906449166329/019fd925-3c20-7138-a64e-f92d8ff723db.webp",
        "width": 928,
        "height": 523
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=488090678205298710&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgewood",
      "poi_latitude": "39.4160859",
      "poi_longitude": "-76.29283790000001",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c978-770e-a1cb-dc460ba0a2a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c978-770e-a1cb-dc460ba0a2a8",
        "storage_key": "property/6767906449166329/019d0268-c978-770e-a1cb-dc460ba0a2a8.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZRzEAvmx4kRFjibxOILxgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58f6934c-b281-43a6-8d92-fc9028b77227",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Aberdeen",
      "poi_type": "Transportation",
      "poi_address": "Amtrak/MARC Station, 18 E Bel Air Ave, Aberdeen, MD 21001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-4f7f-708d-ab54-20f503f2cf8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-4f7f-708d-ab54-20f503f2cf8f",
        "storage_key": "property/6767906449166329/019fd925-4f7f-708d-ab54-20f503f2cf8f.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=ABE",
      "poi_directions_map_url": "https://maps.google.com/?cid=14728176233046477555&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aberdeen",
      "poi_latitude": "39.5084352",
      "poi_longitude": "-76.1631905",
      "poi_miles_from_property": "13.0 mi",
      "poi_walking_minutes": "4 hours 48 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c978-770e-a1cb-dc460ba0a2a8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c978-770e-a1cb-dc460ba0a2a8",
        "storage_key": "property/6767906449166329/019d0268-c978-770e-a1cb-dc460ba0a2a8.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJGbxRqZDBx4kR8woWMED-ZMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9b2177a7-f4df-46a7-8a10-0338156595d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Park and Ride",
      "poi_type": "Transportation",
      "poi_address": "3510 Woodsdale Rd, Abingdon, MD 21009, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-58ca-77cc-890c-975ce32d38c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-58ca-77cc-890c-975ce32d38c3",
        "storage_key": "property/6767906449166329/019fd925-58ca-77cc-890c-975ce32d38c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.harfordcountymd.gov/2273/Park-Ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=6177928483693773511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "park-and-ride",
      "poi_latitude": "39.4642588",
      "poi_longitude": "-76.31185049999999",
      "poi_miles_from_property": "7.8 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c93f-73e8-8522-77b19e4197b6",
        "storage_key": "property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJKRJCwp7nx4kRx8JVTjlpvFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0744f78e-7366-4017-8f72-9716e9f438f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "MVA - Bel Air",
      "poi_type": "Transportation",
      "poi_address": "501 W MacPhail Rd, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-6232-70a1-aa11-a255c05e8f5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-6232-70a1-aa11-a255c05e8f5b",
        "storage_key": "property/6767906449166329/019fd925-6232-70a1-aa11-a255c05e8f5b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2262614761694759932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mva---bel-air",
      "poi_latitude": "39.5201807",
      "poi_longitude": "-76.3433488",
      "poi_miles_from_property": "9.3 mi",
      "poi_walking_minutes": "3 hours 36 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 410-768-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rejLndx4kR_AtfTiNsZh8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5b68091d-b689-4018-8f84-ded26f88c733",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Havre de Grace Park and Ride",
      "poi_type": "Transportation",
      "poi_address": "1796 Level Rd, Havre De Grace, MD 21078, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-6255-721f-8468-b8d08ff02e8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-6255-721f-8468-b8d08ff02e8a",
        "storage_key": "property/6767906449166329/019fd925-6255-721f-8468-b8d08ff02e8a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://roads.maryland.gov/mdotsha/pages/index.aspx?PageId=248",
      "poi_directions_map_url": "https://maps.google.com/?cid=3383116590531514515&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "havre-de-grace-park-and-ride",
      "poi_latitude": "39.5708415",
      "poi_longitude": "-76.1354775",
      "poi_miles_from_property": "19.2 mi",
      "poi_walking_minutes": "7 hours 8 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c93f-73e8-8522-77b19e4197b6",
        "storage_key": "property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJmUrwJNnGx4kRk5BcVJ0-8y4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b6ee9e8e-99e4-43a2-a12c-53b7f45e9c6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Marc Parking - Perryville",
      "poi_type": "Transportation",
      "poi_address": "316-338 Broad St, Perryville, MD 21903, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-7bb1-70e6-a743-b9510fb2e5de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-7bb1-70e6-a743-b9510fb2e5de",
        "storage_key": "property/6767906449166329/019fd925-7bb1-70e6-a743-b9510fb2e5de.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=15970146686891552591&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marc-parking---perryville",
      "poi_latitude": "39.5585193",
      "poi_longitude": "-76.0730538",
      "poi_miles_from_property": "99.7 mi",
      "poi_walking_minutes": "1 day 13 hours",
      "poi_biking_minutes": "1 hour 40 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c93f-73e8-8522-77b19e4197b6",
        "storage_key": "property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJq4Ah-MO5x4kRT28NW8xbod0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b548aa7e-ac70-40e0-aa6d-9174a53a081c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "White Marsh MTA Park & Ride",
      "poi_type": "Transportation",
      "poi_address": "8476 Honeygo Blvd, Baltimore, MD 21236, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-7b45-77c1-8c02-0204148ef78f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-7b45-77c1-8c02-0204148ef78f",
        "storage_key": "property/6767906449166329/019fd925-7b45-77c1-8c02-0204148ef78f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.harfordcountymd.gov/2273/Park-Ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=15265239563552594393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "white-marsh-mta-park--ride",
      "poi_latitude": "39.3774465",
      "poi_longitude": "-76.46149969999999",
      "poi_miles_from_property": "7.7 mi",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c93f-73e8-8522-77b19e4197b6",
        "storage_key": "property/6767906449166329/019d0268-c93f-73e8-8522-77b19e4197b6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJqdtLuyYIyIkR2ZnKHIEG2dM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2dd67300-1a22-4b1f-a458-e24828795967",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Baltimore/Washington International Airport",
      "poi_type": "Transportation",
      "poi_address": "7050 Friendship Rd, Baltimore, MD 21240, USA",
      "poi_short_description": "Airport featuring direct rail service to Baltimore & Washington, DC, plus free WiFi.",
      "poi_long_description": "Airport featuring direct rail service to Baltimore & Washington, DC, plus free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-78f6-7219-a44b-ff63cd40505c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-78f6-7219-a44b-ff63cd40505c",
        "storage_key": "property/6767906449166329/019fd925-78f6-7219-a44b-ff63cd40505c.webp",
        "width": 1280,
        "height": 879
      },
      "poi_business_url": "https://www.bwiairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=23145487996736&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baltimorewashington-international-airport",
      "poi_latitude": "39.1774139",
      "poi_longitude": "-76.6683935",
      "poi_miles_from_property": "27.4 mi",
      "poi_walking_minutes": "10 hours 18 mins",
      "poi_biking_minutes": "2 hours 51 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 410-859-7111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c979-70bf-8df4-67b00320ca28.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c979-70bf-8df4-67b00320ca28",
        "storage_key": "property/6767906449166329/019d0268-c979-70bf-8df4-67b00320ca28.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJC-DCu_zit4kRQBeX-gwVAAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1c6d9f11-5a0e-4505-8ee8-c11eeb744e78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "USAG - Aberdeen Proving Ground",
      "poi_type": "Offices",
      "poi_address": "6836 Civil Rd Building 305, Aberdeen Proving Ground, MD 21005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-8705-714e-9c02-28ef2ccd33cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-8705-714e-9c02-28ef2ccd33cf",
        "storage_key": "property/6767906449166329/019fd925-8705-714e-9c02-28ef2ccd33cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://home.army.mil/apg/index.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=3752533020162196284&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usag---aberdeen-proving-ground",
      "poi_latitude": "39.4753588",
      "poi_longitude": "-76.1152966",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 43 mins",
      "poi_biking_minutes": "1 hour 17 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 410-278-4415",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdAhjszBx4kRPAOxauasEzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a6967683-4b41-4b03-88fc-15f503e390f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Army research lab",
      "poi_type": "Offices",
      "poi_address": "Howitzer Lp, Aberdeen Proving Ground, MD 21005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4952505195537551171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "army-research-lab",
      "poi_latitude": "39.4860639",
      "poi_longitude": "-76.1491655",
      "poi_miles_from_property": "14.2 mi",
      "poi_walking_minutes": "5 hours 13 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "24 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ-pid3PBx4kRQ89KYDzVukQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eadead82-3094-4fa4-a2dd-849aa7052193",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "UM Upper Chesapeake Medical Center Aberdeen",
      "poi_type": "Offices",
      "poi_address": "660 McHenry Rd, Aberdeen, MD 21001, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-8587-763d-8442-bf3afbfc2a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-8587-763d-8442-bf3afbfc2a0a",
        "storage_key": "property/6767906449166329/019fd925-8587-763d-8442-bf3afbfc2a0a.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.umms.org/uch/locations/er-at-um-upper-chesapeake-medical-center-aberdeen",
      "poi_directions_map_url": "https://maps.google.com/?cid=16245089540834286931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "um-upper-chesapeake-medical-center-aberdeen",
      "poi_latitude": "39.5213298",
      "poi_longitude": "-76.1759259",
      "poi_miles_from_property": "14.4 mi",
      "poi_walking_minutes": "5 hours 18 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 443-843-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c26c-77ac-a9fa-6bb35a0fd900",
        "storage_key": "property/6767906449166329/019d0268-c26c-77ac-a9fa-6bb35a0fd900.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYx3g1tbDx4kRU13XAd4mcuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7b384905-a1f1-462e-b787-dd9269119873",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "The University of Maryland Upper Chesapeake Medical Center Bel Air",
      "poi_type": "Offices",
      "poi_address": "500 Upper Chesapeake Dr, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-86ce-73ae-bfed-2595cc8854a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-86ce-73ae-bfed-2595cc8854a3",
        "storage_key": "property/6767906449166329/019fd925-86ce-73ae-bfed-2595cc8854a3.webp",
        "width": 1280,
        "height": 963
      },
      "poi_business_url": "https://www.umms.org/uch/locations/um-upper-chesapeake-medical-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=10782992149238411372&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-university-of-maryland-upper-chesapeake-medical-center-bel-air",
      "poi_latitude": "39.5193321",
      "poi_longitude": "-76.34659409999999",
      "poi_miles_from_property": "8.8 mi",
      "poi_walking_minutes": "3 hours 24 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 443-643-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5d3-70a7-a996-6ff7a81dac63",
        "storage_key": "property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJm3ieVfJdcEARbHAunzripJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8e3bb1f6-c1ea-4412-9111-df81d5aa76c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Johns Hopkins Bayview Medical Center",
      "poi_type": "Offices",
      "poi_address": "4940 Eastern Ave, Baltimore, MD 21224, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-8438-7331-ba4f-a090458ccfba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-8438-7331-ba4f-a090458ccfba",
        "storage_key": "property/6767906449166329/019fd925-8438-7331-ba4f-a090458ccfba.webp",
        "width": 500,
        "height": 500
      },
      "poi_business_url": "https://www.hopkinsmedicine.org/johns_hopkins_bayview/?utm_source=Google&utm_medium=Organic&utm_campaign=Yext&utm_content=FAD&utm_keyword=BAY",
      "poi_directions_map_url": "https://maps.google.com/?cid=4580157047627088255&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johns-hopkins-bayview-medical-center",
      "poi_latitude": "39.2906543",
      "poi_longitude": "-76.5469499",
      "poi_miles_from_property": "15.7 mi",
      "poi_walking_minutes": "5 hours 54 mins",
      "poi_biking_minutes": "1 hour 20 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 410-550-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c5d3-70a7-a996-6ff7a81dac63",
        "storage_key": "property/6767906449166329/019d0268-c5d3-70a7-a996-6ff7a81dac63.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJY5YO5acGyIkRf4FQb5H8jz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_edac3d71-66fe-43fe-aea0-160e9c3d3126",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford Community College",
      "poi_type": "Offices",
      "poi_address": "401 Thomas Run Rd, Bel Air, MD 21015, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd924-c944-7326-be3d-2ace67e0bbd2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd924-c944-7326-be3d-2ace67e0bbd2",
        "storage_key": "property/6767906449166329/019fd924-c944-7326-be3d-2ace67e0bbd2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.harford.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12264388711695330638&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-community-college",
      "poi_latitude": "39.5601692",
      "poi_longitude": "-76.2845403",
      "poi_miles_from_property": "13.5 mi",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 25 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 443-412-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3dFcFLrcx4kRTi3pw43cM6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2a49a116-8a56-4a02-b0e7-7ad9969600ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford County Government Building",
      "poi_type": "Offices",
      "poi_address": "212 S Bond St, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2962786376131634095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-county-government-building",
      "poi_latitude": "39.5336635",
      "poi_longitude": "-76.34851809999999",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDet7pQrdx4kRr2Ox9oLuHSk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d644a446-5832-45fc-9098-fd48de3599f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford County Board of Education",
      "poi_type": "Offices",
      "poi_address": "102 S Hickory Ave, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.hcps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15532242605914110123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-county-board-of-education",
      "poi_latitude": "39.5361628",
      "poi_longitude": "-76.34740599999999",
      "poi_miles_from_property": "9.8 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 410-838-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c593-769c-9fb0-e716f9786a90",
        "storage_key": "property/6767906449166329/019d0268-c593-769c-9fb0-e716f9786a90.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIUOMps7dx4kRq7iyUlucjdc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d6b0e3e2-dd6d-4648-962e-b84d942f8ec6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford County Sheriff's Department",
      "poi_type": "Offices",
      "poi_address": "45 S Main St, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-9ba0-7629-93fd-afdd471c6cc7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-9ba0-7629-93fd-afdd471c6cc7",
        "storage_key": "property/6767906449166329/019fd925-9ba0-7629-93fd-afdd471c6cc7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.harfordsheriff.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9247119607682953460&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-county-sheriffs-department",
      "poi_latitude": "39.5358758",
      "poi_longitude": "-76.3484735",
      "poi_miles_from_property": "9.7 mi",
      "poi_walking_minutes": "3 hours 43 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 410-838-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ42L2m87dx4kR9PB9M0peVIA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_87a024a7-68a1-4247-8aca-ecabff1cede4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "poi_name": "Harford County Health Department - Maryland Children's Health Program",
      "poi_type": "Offices",
      "poi_address": "120 S Hays St Suite 200, Bel Air, MD 21014, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019fd925-8f57-772a-bd58-1246cf7d2fff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fd925-8f57-772a-bd58-1246cf7d2fff",
        "storage_key": "property/6767906449166329/019fd925-8f57-772a-bd58-1246cf7d2fff.webp",
        "width": 1280,
        "height": 607
      },
      "poi_business_url": "https://harfordcountyhealth.com/assistance-programs/maryland-childrens-health-program/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17379206557119373473&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "harford-county-health-department---maryland-childrens-health-program",
      "poi_latitude": "39.5331631",
      "poi_longitude": "-76.3502067",
      "poi_miles_from_property": "9.5 mi",
      "poi_walking_minutes": "3 hours 37 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 410-838-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0268-c974-75ae-b754-68e18d3deb4d",
        "storage_key": "property/6767906449166329/019d0268-c974-75ae-b754-68e18d3deb4d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM_9Iuc_dx4kRoWA940hYL_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_a772741f-05dd-4964-ad77-506e43dce991",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d5a304d0-fdcb-4220-86c1-00d548888c8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d017e3f4-81d2-4e1e-aa66-cd393d9923f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0d7d6975-f78f-4e47-8b3e-99726f83de75",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f4b3caa1-b4a2-46fa-b36e-2e09d2bcb216",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_0b332112-d177-4130-9bce-60b833a3449b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_f59c785c07c89c5989299d78",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "rating": "5",
      "name": "Felecia Johnson",
      "text": "I just want to give a huge shoutout to the maintenance team here at Mariners Pointe — Joe, Man, James , the supervisor Dennis, and Curtis. They’re seriously the best! Anytime I put in a maintenance request, they’re quick to respond and always get things taken care of right away. Everyone on the team is so friendly and respectful every time they come by, and you can tell they really care about keeping the property in great shape. Curtis also does such a great job keeping the grounds looking clean and beautiful. It makes living here that much better knowing we have such a dependable and kind maintenance crew. Thank you all for everything you do!",
      "date": "2025-10-15",
      "title": "false"
    },
    {
      "id": "ec_d596418d087620ed360c8b90",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "rating": "5",
      "name": "Theodore Roman",
      "text": "I just want to say how pleased i have been with James as our maintenance man. Anytime we've had any issues he responds fast and with a smile. He’s very professional, respectful and always makes sure the job is done. It's great to have someone reliable like James to call on!",
      "date": "2025-11-06",
      "title": "false"
    },
    {
      "id": "ec_559037636d1df9e2fd2f76aa",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "rating": "4",
      "name": "Dietra Lockridge",
      "text": "I’ve been here just under a month and overall it has been a nice experience. My water heater went up, called and they came right out. Unfortunately, they had to come back the next day. Joe was absolutely amazing, he’s very knowledgeable and skilled. I can’t thank him enough for replacing the water heater and giving me hot water again.",
      "date": "2025-10-23",
      "title": "false"
    },
    {
      "id": "ec_c56c7e6fbd73073a901e8e8b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "rating": "5",
      "name": "Brandy Arthur",
      "text": "I have a new friend!! His name is James and he is my maintenance man. He went above and beyond for me yesterday. The whole maintenance team is great. James and JOE!!  Love that guy too. There so efficient and timely. And ALWAYS go out of their way!! Thanks Guys!!!",
      "date": "2025-10-30",
      "title": "false"
    },
    {
      "id": "ec_98dd6e265517cfc836d80ceb",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "rating": "5",
      "name": "Brenda Henderson",
      "text": "I live in a three-bedroom at Mariners Pointe and I honestly love it! Office staff karrel , Kiersten and Stacy are the best and helpful!\nThe townhome is really nice and spacious, and the price is amazing for what you get. The area feels safe, the neighbors are friendly, and the schools around here are definitely better than other areas I’ve lived in. It’s been a great experience so far — highly recommend it to anyone looking for a nice, affordable place to live!",
      "date": "2025-10-15",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_9887acdb-e86a-4743-acfd-b47c902e0dc2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019d0269-32a6-71d7-8fcd-db9170d3541a.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Interior view of a kitchen with stainless steel appliances, dark wood cabinets, and a stacked washer/dryer.",
        "public_id": "019d0269-32a6-71d7-8fcd-db9170d3541a",
        "storage_key": "property/6767906449166329/019d0269-32a6-71d7-8fcd-db9170d3541a.webp",
        "width": 2000,
        "height": 1000
      },
      "virtual_tour_title": " Mariner's Pointe Tours",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6493605ceaa103238da4b22b&sourceId=1001"
    },
    {
      "id": "custom_6db987bf-bf45-4536-becd-755571d960b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019deca9-fdcf-7359-93bf-e3a00c6b2838.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019deca9-fdcf-7359-93bf-e3a00c6b2838",
        "storage_key": "property/6767906449166329/019deca9-fdcf-7359-93bf-e3a00c6b2838.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 850 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=FcYLmpJix9q"
    },
    {
      "id": "custom_cabf7140-3d76-4574-b76f-f74f2fe2bec9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019decaa-02d3-724e-b0e9-4e3abd1573c7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019decaa-02d3-724e-b0e9-4e3abd1573c7",
        "storage_key": "property/6767906449166329/019decaa-02d3-724e-b0e9-4e3abd1573c7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA Townhome - 900 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BvwUpHBQUnd"
    },
    {
      "id": "custom_82292665-b383-4c65-aa77-52f9a1e3851e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019decaa-031b-70ca-ba5c-1616835f4c0c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019decaa-031b-70ca-ba5c-1616835f4c0c",
        "storage_key": "property/6767906449166329/019decaa-031b-70ca-ba5c-1616835f4c0c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 750 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sU3gXV3fow1"
    },
    {
      "id": "custom_d13a2e50-d349-47b4-b866-07e7cc79025a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/019decaa-0389-766d-8055-e2c9d3d9a1e0.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019decaa-0389-766d-8055-e2c9d3d9a1e0",
        "storage_key": "property/6767906449166329/019decaa-0389-766d-8055-e2c9d3d9a1e0.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 1BA-1080 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=i1iX14gyfrn"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_b0278270794f94626938b311",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429098",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 25,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1e2f1be0b3b1adfbbb3180c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429099",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_3b51da62600d5414c63ec5b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429100",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f47a1e1e1d891a5d541bf55f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429101",
      "name": "Pet Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e863ee1780c2fea813dd1578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429102",
      "name": "Commercial Vehicle Parking",
      "description": "false",
      "amount": 40,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_38c52d21beb75e4cfa5c543d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429105",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6e86d37687efd11cb69a9160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429107",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c62f3d6996ec1a6299146ec7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429108",
      "name": "Reserved Parking Space",
      "description": "false",
      "amount": 40,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "parking",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_6f587d158b4317fdaaf3a65f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429109",
      "name": "Storage Space",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_66e89a31b6bbc7eb29da154c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429110",
      "name": "Transfer Fee",
      "description": "Transfer fee is 50% of rent; minimum $500",
      "amount": 500,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_23df41fff38bc6dbb5037e14",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "429111",
      "name": "Trash Service",
      "description": "false",
      "amount": 18,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cf798563542b991bf9a40b5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "540997",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 4.53,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4ea384f00b136efff62f11a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "540998",
      "name": "Utility - New Account Fee",
      "description": "false",
      "amount": 10,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_48f67ac6b79ecea97a780ee4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "543063",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9fb1896e32b3329db4a57c48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "543065",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7707fabe8bfd0cd5403b07c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "835148",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_0851fad05f8578d359709ff1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "838615",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2c9a40d38df3d7f0670f8cdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "engrain",
      "external_id": "945447",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a286d-8692-702e-87be-5cb734341c13",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-mariners-pointe-auto",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329"
    },
    {
      "lead_collector_id": "019c3043-7220-7115-a7e3-b1d1ef00d949",
      "lead_source": "FACEBOOK_ADS",
      "name": "mariners-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329"
    },
    {
      "lead_collector_id": "019c3043-728f-7644-9292-93f837b52101",
      "lead_source": "LANDING_PAGE",
      "name": "mariners-pointe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "dog-friendly-apartments-joppatowne-md-383",
      "search_query": "dog-friendly apartments Joppatowne MD",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Joppatowne, MD",
      "h2_subtitle": "Explore dog-friendly apartments in Joppatowne, MD. Mariner's Pointe offers a welcoming community for you and your furry friends.",
      "page_copy": "Discover the ideal pet-friendly living at Mariner's Pointe in Joppatowne, MD. Our spacious one to three-bedroom apartments are perfect for you and your furry companions. Enjoy our on-site dog park where pets can romp and play freely, making Mariner's Pointe truly stand out among dog-friendly apartments in Joppatowne, MD. \n\nIn addition to our pet-friendly amenities, you'll find a host of other conveniences such as a playground and storage space. Plus, with short-term leases available and Baltimore's Inner Harbor just a short drive away, Mariner's Pointe offers both flexibility and prime location, ensuring you and your pet have everything you need. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Joppatowne, MD",
      "seo_description": "Find pet-friendly living at Mariner's Pointe, Joppatowne, MD. Enjoy a dog park & more. Perfect for you & your pet. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-with-ev-charging-harford-county-45",
      "search_query": "apartments with EV charging Harford County",
      "category": "Amenity",
      "h1_title": "Apartments with EV Charging in Harford County",
      "h2_subtitle": "Discover apartments with EV charging in Harford County. Mariner's Pointe offers convenient amenities for eco-conscious residents.",
      "page_copy": "At Mariner's Pointe in Harford County, we recognize the importance of sustainable living. Our community is setting the standard by offering apartments with EV charging options, catering to our eco-conscious residents. Situated in Joppatowne, MD, our spacious one to three-bedroom apartments are both convenient and comfortable, featuring excellent amenities such as a dog park and playground.\n\nOnly a short drive from Baltimore's Inner Harbor, Mariner's Pointe combines environmental consideration with accessibility. With storage options and short-term leases available, we provide the flexibility and features that modern apartment seekers desire. Check availability or schedule a tour to see how we can accommodate your lifestyle today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with EV Charging in Harford County",
      "seo_description": "Eco-friendly living at Mariner's Pointe, Harford County. Enjoy EV charging, dog park & more. Your sustainable home is here - schedule a visit today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "playground-equipped-apartments-21085-285",
      "search_query": "playground-equipped apartments 21085",
      "category": "Amenity",
      "h1_title": "Playground-Equipped Apartments in 21085",
      "h2_subtitle": "Explore playground-equipped apartments in the 21085 area. Mariner's Pointe offers family-friendly living with a private playground.",
      "page_copy": "Welcome to Mariner's Pointe, the perfect blend of comfort and family-friendly living in the 21085 area. Our playground-equipped apartments make it easy for families to enjoy outdoor fun without leaving the community. Offering one to three-bedroom units, Mariner's Pointe caters to families looking for a vibrant, active setting to call home.\n\nIn addition to our private playground, residents benefit from amenities that enhance daily life, such as a dog park and convenient storage spaces. With our location just 28 minutes from Baltimore’s Inner Harbor, you’ll have access to both small-town charms and big-city amenities. Contact us today to learn how Mariner's Pointe can suit your family’s needs!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground-Equipped Apartments in 21085",
      "seo_description": "Find family-friendly living at Mariner's Pointe, 21085. Enjoy on-site playground, dog park & more. Perfect for families - schedule your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "reserved-parking-apartments-near-baltimore-510",
      "search_query": "reserved parking apartments near Baltimore",
      "category": "Amenity",
      "h1_title": "Reserved Parking Apartments Near Baltimore",
      "h2_subtitle": "Find reserved parking apartments near Baltimore at Mariner's Pointe. Enjoy ease and convenience with guaranteed parking spots.",
      "page_copy": "Mariner's Pointe offers the convenience of reserved parking just minutes from Baltimore. Our community caters to those who seek stress-free living with secure parking options in Joppatowne, MD. With spacious one to three-bedroom layouts, these apartments are ideal for commuters and city lovers alike. \n\nResidents can take advantage of our wide range of amenities, including a playground and dog park, adding extra value to an already appealing offer. Located only 28 minutes from Baltimore’s Inner Harbor, Mariner's Pointe delivers both convenience and comfort. Discover the difference today by inquiring about our reserved parking and schedule a tour of your future home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Reserved Parking Apartments Near Baltimore",
      "seo_description": "Mariner's Pointe offers reserved parking just outside Baltimore. Enjoy easy access and great amenities. Contact us to secure your parking spot!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-joppatowne-126",
      "search_query": "in-unit laundry apartments Joppatowne",
      "category": "Amenity",
      "h1_title": "In-Unit Laundry Apartments in Joppatowne",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry apartments in Joppatowne at Mariner's Pointe, your ideal home with top-notch amenities.",
      "page_copy": "Discover the comfort of in-unit laundry apartments in Joppatowne at Mariner's Pointe. Our community offers the luxury of having laundry facilities right in your home, simplifying your daily routine. Choose from our selection of spacious one to three-bedroom layouts that perfectly suit your lifestyle.\n\nBeyond the appeal of in-unit laundry, Mariner's Pointe boasts a variety of amenities, including a dog park, playground, and convenient access to Baltimore's Inner Harbor. Located in the heart of Harford County, our community blends suburban tranquility with urban accessibility. Schedule a visit today and experience the unmatched convenience and comfort of Mariner's Pointe.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Joppatowne",
      "seo_description": "Find in-unit laundry apartments in Joppatowne at Mariner's Pointe. Enjoy convenience, comfort, and amenities - book your tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-joppatowne-md-262",
      "search_query": "one bedroom apartments joppatowne md",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Joppatowne, MD",
      "h2_subtitle": "Explore one bedroom apartments in Joppatowne, MD at Mariner's Pointe. Perfect for individuals or couples seeking comfort and convenience.",
      "page_copy": "Mariner's Pointe in Joppatowne, MD, offers versatile one-bedroom apartments that cater to both individuals and couples. Our thoughtfully designed units provide a cozy retreat, blending comfort with modern conveniences. Situated in a vibrant community, these apartments make an ideal choice for those wanting a practical living space.\n\nResidents enjoy premium amenities, including a dog park and playground, enhancing the living experience. Being just 28 minutes from Baltimore's Inner Harbor, Mariner's Pointe offers the best of both worlds—proximity to city life while nestled in a serene suburban environment. Contact us today to explore our one-bedroom options and find your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Joppatowne, MD",
      "seo_description": "Find ideal one bedroom apartments in Joppatowne, MD at Mariner's Pointe. Comfortable living with great amenities. Explore your options today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-harford-county-293",
      "search_query": "two bedroom apartments harford county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Harford County",
      "h2_subtitle": "Discover spacious two bedroom apartments in Harford County at Mariner's Pointe, perfect for families or roommates.",
      "page_copy": "Looking for two bedroom apartments in Harford County? Mariner's Pointe provides spacious and well-appointed layouts that suit families and roommates alike. Our apartments are designed with comfort in mind, offering ample space and thoughtful amenities in Joppatowne, MD.\n\nDive into community features such as a dog park, playground, and storage space options, making our two-bedroom units a practical choice for modern living. With a short 28-minute drive to Baltimore's Inner Harbor, residents enjoy easy city access while relishing suburban tranquility. Visit us today to explore how Mariner's Pointe can be your perfect home in Harford County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Harford County",
      "seo_description": "Find spacious two bedroom apartments in Harford County at Mariner's Pointe. Enjoy comfort, convenience, and excellent amenities. Contact us!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "three-bedroom-apartments-near-21085-423",
      "search_query": "three bedroom apartments near 21085",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 21085",
      "h2_subtitle": "Explore roomy three bedroom apartments near the 21085 area at Mariner's Pointe, ideal for growing families or those needing extra space.",
      "page_copy": "For those seeking three bedroom apartments near the 21085 area, Mariner's Pointe offers an exceptional living experience in Joppatowne, MD. Our spacious layouts are designed to provide plenty of room for growing families or anyone needing additional space, making them perfect for family living or roommates who want comfort and convenience.\n\nMariner's Pointe is not only situated in a prime location with quick access to local parks and Baltimore, but it also offers a wealth of amenities, such as a welcoming dog park and a fun playground. Our community combines suburban peace with city convenience, providing the best of both worlds. Reach out today to learn more about our exceptional three-bedroom options and find your next home in Harford County!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near 21085",
      "seo_description": "Find spacious three bedroom apartments near 21085 at Mariner's Pointe. Ideal for families with modern amenities. Discover your new home today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-near-joppatowne-elementary-school-md-79",
      "search_query": "apartments near Joppatowne Elementary School MD",
      "category": "School",
      "h1_title": "Apartments Near Joppatowne Elementary School",
      "h2_subtitle": "Discover perfect family-friendly apartments near Joppatowne Elementary School at Mariner's Pointe. Convenient location and great amenities!",
      "page_copy": "Location is key when finding the right home, and Mariner's Pointe offers excellent apartments near Joppatowne Elementary School, MD. Ideal for families, these apartments provide easy access to quality education while enjoying a comfortable, community-oriented living environment.\n\nMariner's Pointe offers a fantastic blend of convenience and amenities, such as a dog park, playground, and short-term lease options, catering to varying family needs. Nestled in Harford County, our community not only champions convenience to school and parks but also boasts quick access to Baltimore's Inner Harbor, ensuring you're well-connected. Schedule a tour today and see why Mariner's Pointe is perfect for families!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Joppatowne Elementary School",
      "seo_description": "Find family-friendly apartments near Joppatowne Elementary School. Mariner's Pointe offers convenient living with great amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-close-to-magnolia-elementary-school-243",
      "search_query": "apartments close to Magnolia Elementary School Harford County",
      "category": "School",
      "h1_title": "Apartments Close to Magnolia Elementary School",
      "h2_subtitle": "Discover ideal family apartments close to Magnolia Elementary School in Harford County at Mariner's Pointe.",
      "page_copy": "If you’re searching for apartments close to Magnolia Elementary School in Harford County, Mariner's Pointe is your ideal choice. Our community offers spacious living spaces that cater to families seeking proximity to quality education and a strong sense of community.\n\nAt Mariner's Pointe, enjoy amenities that enrich family life, including a playground and a large dog park, while benefiting from a mere 28-minute commute into Baltimore. Located in the welcoming area of Joppatowne, MD, our apartments provide the perfect blend of modern convenience and suburban tranquility. Contact us today to explore what we can offer your family!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Magnolia Elementary School",
      "seo_description": "Find family-friendly apartments close to Magnolia Elementary School in Harford County. Discover Mariner's Pointe with great amenities today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "spacious-apartments-near-magnolia-middle-school-494",
      "search_query": "spacious apartments near Magnolia Middle School Joppatowne",
      "category": "School",
      "h1_title": "Spacious Apartments Near Magnolia Middle School",
      "h2_subtitle": "Explore spacious living near Magnolia Middle School in Joppatowne at Mariner's Pointe, featuring ideal family-friendly amenities.",
      "page_copy": "For families seeking spacious apartments near Magnolia Middle School in Joppatowne, Mariner's Pointe provides the perfect environment. Our generously designed units offer ample room, tailored to accommodate growing families or those desiring more space, close to one of the area's most notable schools.\n\nLiving at Mariner's Pointe means enjoying access to fantastic community amenities like a family-friendly playground and a wide-open dog park, all within a short distance of both educational and entertainment hubs. With a strategic location in Harford County, these apartments promise a convenient lifestyle with quick commutes into Baltimore. Visit us to discover your new spacious abode today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Spacious Apartments Near Magnolia Middle School",
      "seo_description": "Find roomy apartments near Magnolia Middle School in Joppatowne. Mariner's Pointe offers family-friendly living with top amenities. Discover today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "find-apartments-near-joppatowne-high-school-21085-492",
      "search_query": "find apartments near Joppatowne High School 21085",
      "category": "School",
      "h1_title": "Find Apartments Near Joppatowne High School",
      "h2_subtitle": "Discover convenient living in 21085 near Joppatowne High School at Mariner's Pointe. Perfect for families seeking quality education and amenities.",
      "page_copy": "Searching for the right home starts with location, and at Mariner's Pointe, you can find apartments near Joppatowne High School, right in the heart of the 21085 area. Our community is perfectly positioned for families prioritizing education and convenience, ensuring your commute to school is always a breeze.\n\nMariner's Pointe provides a variety of amenities to enhance family living, such as a spacious playground, dog park, and short-term lease options for added flexibility. Situated in Joppatowne, MD, residents also enjoy proximity to local parks and a quick route to Baltimore's vibrant Inner Harbor. Experience the ease of living near top schools and schedule your tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Joppatowne High School",
      "seo_description": "Discover apartments near Joppatowne High School in 21085 at Mariner's Pointe. Convenient, family-friendly living with great amenities awaits!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-by-riverside-elementary-school-610",
      "search_query": "apartments by Riverside Elementary School in Harford County",
      "category": "School",
      "h1_title": "Apartments by Riverside Elementary School",
      "h2_subtitle": "Explore family-friendly apartments by Riverside Elementary School in Harford County. Enjoy modern amenities and a prime location.",
      "page_copy": "Looking for apartments by Riverside Elementary School in Harford County? Mariner's Pointe offers the perfect setting for families, combining comfortable living spaces with a prime location near one of the area's respected schools. Our spacious one to three-bedroom apartments are designed with family needs in mind.\n\nResidents of Mariner's Pointe benefit from an array of amenities, including a well-equipped dog park, a large playground, and easy access to Baltimore's inner city. Located in Joppatowne, our community brings the convenience of nearby educational institutions together with suburban peace. Ready to find your new home? Visit us to experience Mariner's Pointe today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Riverside Elementary School",
      "seo_description": "Discover family-friendly apartments near Riverside Elementary School in Harford County. Mariner's Pointe offers great amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "nearby-apartments-to-trinity-lutheran-christian-school-203",
      "search_query": "nearby apartments to Trinity Lutheran Christian School Joppatowne",
      "category": "School",
      "h1_title": "Nearby Apartments to Trinity Lutheran Christian",
      "h2_subtitle": "Discover Mariner's Pointe's nearby apartments to Trinity Lutheran Christian School in Joppatowne, where convenience meets comfort.",
      "page_copy": "Situated in the heart of Joppatowne, Mariner's Pointe offers nearby apartments to Trinity Lutheran Christian School, making it an ideal choice for families aiming for convenience and quality living. Our thoughtfully designed living spaces ensure comfort, while keeping you close to top educational options.\n\nResidents will appreciate the community's engaging amenities, such as our expansive playground and the freedom of a private dog park. Enjoy the perks of living in Harford County with easy access to both local attractions and Baltimore's bustling downtown. Mariner's Pointe is where convenience meets lifestyle. Schedule a visit today and see how perfectly situated your future home can be!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Trinity Lutheran Christian",
      "seo_description": "Find convenient apartments near Trinity Lutheran Christian School in Joppatowne at Mariner's Pointe. Ideal location with excellent amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-near-medstar-franklin-square-medical-center-369",
      "search_query": "apartments near MedStar Franklin Square Medical Center Joppatowne MD",
      "category": "Hospital",
      "h1_title": "Apartments Near MedStar Franklin Square",
      "h2_subtitle": "Discover Mariner's Pointe, offering modern apartments near MedStar Franklin Square Medical Center in Joppatowne, MD. Ideal for healthcare professionals.",
      "page_copy": "Mariner's Pointe provides the perfect home for those searching for apartments near MedStar Franklin Square Medical Center in Joppatowne, MD. Our community offers a serene living environment with easy commutes, making it an excellent choice for healthcare workers and their families.\n\nResidents enjoy modern amenities, such as a dedicated dog park and a well-equipped playground, along with the convenience of being just a short drive from Baltimore's Inner Harbor. Whether you're a MedStar professional seeking a nearby residence or simply value proximity to quality healthcare, Mariner's Pointe offers a seamless blend of comfort and accessibility. Visit today and explore our vibrant community!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near MedStar Franklin Square MD",
      "seo_description": "Discover Mariner's Pointe in Joppatowne, offering convenient apartments near MedStar Franklin Square Medical Center. Ideal for healthcare professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-near-mariner-point-park-joppatowne-852",
      "search_query": "apartments near mariner point park joppatowne",
      "category": "Park",
      "h1_title": "Apartments Near Mariner Point Park",
      "h2_subtitle": "Explore life at Mariner's Pointe, offering charming apartments near Mariner Point Park in Joppatowne. Perfect for nature lovers and outdoor enthusiasts.",
      "page_copy": "Nestled in the heart of Joppatowne, Mariner's Pointe is the ideal choice for those seeking apartments near Mariner Point Park. Our community offers spacious one to three-bedroom homes surrounded by the natural beauty of Maryland.\n\nResidents at Mariner’s Pointe can embrace an active lifestyle with the park just a stone's throw away, while also enjoying community features like a playground and dog park on-site. Additionally, the proximity to Baltimore adds urban adventures to your agenda. Experience the best of both worlds: tranquility and convenience at Mariner’s Pointe, where outdoor enthusiasts can truly thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Mariner Point Park Joppatowne",
      "seo_description": "Find your perfect home at Mariner's Pointe. Conveniently located near Mariner Point Park in Joppatowne, ideal for nature lovers and families.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-close-to-copenhaver-park-md-769",
      "search_query": "apartments close to copenhaver park md",
      "category": "Park",
      "h1_title": "Apartments Close to Copenhaver Park",
      "h2_subtitle": "Discover Mariner's Pointe, offering beautiful apartments close to Copenhaver Park, MD. Perfect for those who love the great outdoors.",
      "page_copy": "For families and individuals seeking a home near scenic landscapes, Mariner's Pointe presents an ideal location with apartments close to Copenhaver Park in MD. Enjoy a community where spacious living meets an active lifestyle.\n\nWith a range of amenities including a dedicated dog park, playground, and easy access to local recreation areas, Mariner’s Pointe enhances your living experience. The proximity to Baltimore further provides urban conveniences. Whether it's a walk in the park or a short drive to the city, living at Mariner’s Pointe puts the best of Maryland at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Copenhaver Park MD",
      "seo_description": "Experience life at Mariner’s Pointe with apartments close to Copenhaver Park, MD. Ideal for outdoor lovers seeking community and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "susquehanna-state-park-harford-county-apartments-955",
      "search_query": "susquehanna state park harford county apartments",
      "category": "Park",
      "h1_title": "Apartments Near Susquehanna State Park",
      "h2_subtitle": "Live at Mariner's Pointe, offering delightful apartments near Susquehanna State Park in Harford County. Perfect for nature and adventure lovers.",
      "page_copy": "Mariner's Pointe offers an idyllic retreat for those looking for apartments near Susquehanna State Park in Harford County. Our community seamlessly blends the tranquility of nature with modern living comforts, making it an ideal choice for outdoor enthusiasts.\n\nResidents can explore numerous trails and outdoor activities at the nearby state park while enjoying amenities such as a dog park and playground back home. With Baltimore just a short drive away, Mariner's Pointe offers a balanced lifestyle of urban access and natural beauty, providing a perfect backdrop for your home adventures.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Susquehanna State Park Apartments",
      "seo_description": "Explore Mariner's Pointe in Harford County. Offering apartments near majestic Susquehanna State Park. Perfect for nature lovers.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "millard-tydings-memorial-park-nearby-apartments-726",
      "search_query": "millard tydings memorial park nearby apartments",
      "category": "Park",
      "h1_title": "Apartments Near Millard Tydings Park",
      "h2_subtitle": "Find comfortable living at Mariner's Pointe, with nearby apartments to Millard Tydings Memorial Park. Perfect for relaxation and recreation.",
      "page_copy": "Discover Mariner's Pointe, where you can find the ideal living space with apartments near Millard Tydings Memorial Park. Our Joppatowne community offers a harmonious blend of comfort and convenience, perfect for those who cherish the outdoors.\n\nAt Mariner’s Pointe, residents enjoy spacious apartment layouts and enticing amenities such as a dog park and playground, all while being a short drive from the natural beauty of Millard Tydings Memorial Park. This location offers easy access to Baltimore, ensuring a lifestyle that combines tranquility with city living options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Millard Tydings Memorial Park",
      "seo_description": "Discover Mariner's Pointe with apartments close to Millard Tydings Memorial Park, offering the perfect mix of comfort and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166329",
      "source": "custom",
      "page_item_url": "apartments-near-baltimore-washington-international-airport-md-374",
      "search_query": "apartments near baltimore washington international airport md",
      "category": "Transit",
      "h1_title": "Apartments Near BWI Airport, MD",
      "h2_subtitle": "Discover convenient living at Mariner's Pointe—your apartments near Baltimore Washington International Airport in MD. Ideal for travelers.",
      "page_copy": "Mariner's Pointe offers a prime location for those seeking apartments near Baltimore Washington International Airport, MD. Our Joppatowne community provides a comfortable living environment with seamless access to major transportation hubs.\n\nEnjoy the serene setting of our property with its ample amenities, such as a dog park and playground, while being only a short drive from BWI Airport. Perfect for frequent travelers and city commuters, Mariner’s Pointe blends connectivity with a welcoming neighborhood atmosphere.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
      "featured_image_media": {
        "alt_text": "Balcony view of trees and grass, with a walkway leading past brick buildings.",
        "public_id": "01a015da-85cf-712d-9140-0c995a46560d",
        "storage_key": "property/6767906449166329/01a015da-85cf-712d-9140-0c995a46560d.webp",
        "width": 3072,
        "height": 2051
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near BWI Airport, MD",
      "seo_description": "Find your home at Mariner's Pointe with apartments close to BWI Airport. Perfect blend of convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5066"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976264821"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973452"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T37VKM6K"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://livemarinerspointe.fatwin.com/api/websites/resources/1?x=L2JTQlI1eVB4OEZXbVFhRzNqb2cwcTQyb3ZQazdXNFBVRkVVU1ZLWVBpMGdRUVN2RGdlaW9PQS9CRmw1cGtwVDdObVl2clJPbTBCWnFyeUxaMmlOV3c9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52817609217"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rkwnlz3gvd2"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "9548b02e-43e6-11ef-85f3-5bf4b2a4d589"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548b02e-43e6-11ef-85f3-5bf4b2a4d589/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548b02e-43e6-11ef-85f3-5bf4b2a4d589/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZ6YVdsbnFLRDVMOTNEMlJFUmxLaGc9PSIsInZhbHVlIjoicnBwS3NsK21lYm9LdFJYWXNTWnZldz09IiwibWFjIjoiMzVlN2FiNGM3ZWFjODU2ZWEwYjNjOWI5NjVhZjI1ZWFiMGIwYTE5YTJlOGNmNDA4M2MyZDI2ZjEzYTdlODQzYSJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5066",
  "custom_repli_id": "9976264821",
  "custom_realpage_id": "4973452",
  "custom_google_gtm_id": "GTM-T37VKM6K",
  "custom_perq_script_url": "https://livemarinerspointe.fatwin.com/api/websites/resources/1?x=L2JTQlI1eVB4OEZXbVFhRzNqb2cwcTQyb3ZQazdXNFBVRkVVU1ZLWVBpMGdRUVN2RGdlaW9PQS9CRmw1cGtwVDdObVl2clJPbTBCWnFyeUxaMmlOV3c9PQ2",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_hubspot_company_id": "52817609217",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rkwnlz3gvd2",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "9548b02e-43e6-11ef-85f3-5bf4b2a4d589",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548b02e-43e6-11ef-85f3-5bf4b2a4d589/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/9548b02e-43e6-11ef-85f3-5bf4b2a4d589/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZ6YVdsbnFLRDVMOTNEMlJFUmxLaGc9PSIsInZhbHVlIjoicnBwS3NsK21lYm9LdFJYWXNTWnZldz09IiwibWFjIjoiMzVlN2FiNGM3ZWFjODU2ZWEwYjNjOWI5NjVhZjI1ZWFiMGIwYTE5YTJlOGNmNDA4M2MyZDI2ZjEzYTdlODQzYSJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "f60bfed2-df10-44ce-9bec-d5ef0aa22369",
  "custom_audioeye_site_hash": "c9bba6f06cf3964b9d5ffc5902a402b2"
};

export const generatedAt = '2026-10-22T20:07:12.241Z';
